<template>
	<div :class="layoutContainerClass" @click="onDocumentClick">
		<AppTopBar 
		:horizontal="menuMode==='horizontal'" 
		:topbarMenuActive="topbarMenuActive" 
		:activeTopbarItem="activeTopbarItem" 
		:mobileTopbarActive="mobileTopbarActive" 
		@topbar-mobileactive="onTopbarMobileButtonClick"
		@menubutton-click="onMenuButtonClick" 
		@topbar-menubutton-click="onTopbarMenuButtonClick" 
		@topbaritem-click="onTopbarItemClick" 
		@rightpanel-button-click="onRightPanelButtonClick"
		:searchActive="searchActive" 
		@search-toggle="onSearchToggle" 
		@search-click="onSearchClick" 
		@search-hide="onSearchHide"></AppTopBar>

			<template v-if="$route.path != this.$store.getters['infoNavigation/Rol']+'/select-customer'">
			<div class="menu-wrapper">
				<div class="layout-menu-container" @click="onMenuClick">
					<!-- <div class="layout-inline-menu">
						<a class="layout-inline-menu-action flex flex-row align-items-center" :class="menuMode === 'horizontal' ? 'p-3 lg:p-1 py-3' : 'p-3'" :style="{'min-width': menuMode === 'horizontal' ? '165px' : 0} " @click="onClick($event)">
							<img :src="img_profile" alt="avatar" style="width: 35px; height: 35px;margin-left: 5px;border-radius: 25px;">
							<span class="flex flex-column ml-2">
								<span class="font-bold">{{nombre}}</span>
								<small>{{ this.$store.getters['infoNavigation/NameCustomer'] }}</small>
							</span>
						</a>
					</div> -->
						<AppInlineMenu v-if="inlineMenuPosition === 'top' || inlineMenuPosition === 'both'" v-model:active="inlineMenuTopActive" @change-inlinemenu="onChangeInlineMenu" inlineMenuKey="top" :menuMode="menuMode"></AppInlineMenu>
						<template v-if="this.$store.getters['infoNavigation/IdRol'] == 1">
							<AppMenu :model="menu_especiales" :menuMode="menuMode" :active="menuActive" :mobileMenuActive="mobileMenuActive" :isSlimOrHorItemClick="isSlimOrHorItemClick" @menuitem-click="onMenuItemClick" @root-menuitem-click="onRootMenuItemClick"></AppMenu>
						</template>
						<template v-if="this.$store.getters['infoNavigation/IdRol'] == 2">
							<AppMenu :model="menu_generadores" :menuMode="menuMode" :active="menuActive" :mobileMenuActive="mobileMenuActive" :isSlimOrHorItemClick="isSlimOrHorItemClick" @menuitem-click="onMenuItemClick" @root-menuitem-click="onRootMenuItemClick"></AppMenu>
						</template>
						<template v-if="this.$store.getters['infoNavigation/IdRol'] == 5">
						<AppMenu 
						:model="menu"
						:menuMode="menuMode" 
						:active="menuActive" 
						:mobileMenuActive="mobileMenuActive" 
						:isSlimOrHorItemClick="isSlimOrHorItemClick" 
						@menuitem-click="onMenuItemClick" 
						@root-menuitem-click="onRootMenuItemClick"
						></AppMenu>
							<!-- <AppMenu :model="menu_empresa_transporte" :menuMode="menuMode" :active="menuActive" :mobileMenuActive="mobileMenuActive" :isSlimOrHorItemClick="isSlimOrHorItemClick" @menuitem-click="onMenuItemClick" @root-menuitem-click="onRootMenuItemClick"></AppMenu> -->
							<!-- <AppInlineMenu v-if="inlineMenuPosition === 'bottom' || inlineMenuPosition === 'both'" v-model:active="inlineMenuBottomActive" @change-inlinemenu="onChangeInlineMenu" inlineMenuKey="bottom" :menuMode="menuMode"></AppInlineMenu> -->
						</template>
						<template v-if="this.$store.getters['infoNavigation/IdRol'] == 6">
							<AppMenu :model="menuSize" :menuMode="menuMode" :active="menuActive" :mobileMenuActive="mobileMenuActive" :isSlimOrHorItemClick="isSlimOrHorItemClick" @menuitem-click="onMenuItemClick" @root-menuitem-click="onRootMenuItemClick"></AppMenu>
						</template>
						
				</div>
				<template v-if="loader==true">
					<ProgressBar mode="indeterminate" style="height: .5em" />
				</template>
			</div>
			</template>


		<div class="layout-main">
			<Toast />
			<ConfirmDialog />
			<template v-if="loader==true">
				<ProgressBar mode="indeterminate" style="height: .5em" />
			</template>
			<div class="layout-content">
				<router-view></router-view>
			</div>

			<AppFooter :layoutMode="layoutMode" />
		</div>

		<!-- <AppConfig :menuMode="menuMode" @menu-mode-change="onMenuModeChange" @layout-mode-change="onLayoutModeChange" @menu-theme="onMenuTheme"
				:layoutMode="d_layoutMode" @topbar-theme="onTopbarThemeChange"
				v-model:inlineMenuPosition="inlineMenuPosition" @inlinemenu-change="onInlineMenuPositionChange"
				:theme="theme" :themes="themes" @theme-change="changeTheme" :menuTheme="d_menuTheme" :menuThemes="menuThemes"
				:topbarTheme="d_topbarTheme" :topbarThemes="topbarThemes"></AppConfig> -->

		<div v-if="mobileMenuActive" class="layout-mask modal-in"></div>
		<!-- ══ MODAL REPORTES ══ -->
		<Dialog v-model:visible="ModalReport" :style="{width:'580px'}"
				header="Descargar Reportes" :modal="true" class="rp-dialog">
		<div class="rp-modal-body">

			<!-- ── Selección de empresa (Generador puede trabajar con varias transportadoras) ── -->
			<template v-if="$store.getters['infoNavigation/IdRol'] == 2 && reporte_customer_selected == null">
				<div class="rp-section-label">
					<i class="pi pi-building"></i> Seleccione la empresa de transporte
				</div>
				<template v-if="reporte_customers_group.length > 0">
					<Dropdown v-model="reporte_customer_selected" :showClear="true"
						:options="reporte_customers_group" optionLabel="name" optionValue="id_customer"
						placeholder="Seleccione una empresa…" style="width:100%;margin-bottom:1rem" />
				</template>
				<template v-else>
					<p style="color:#6b7280;font-size:.85rem">No tiene empresas de transporte asociadas.</p>
				</template>
			</template>

			<TabView v-if="$store.getters['infoNavigation/IdRol'] != 2 || reporte_customer_selected != null">

			<!-- ── Tab PESV ── -->
			<TabPanel v-if="opcionesReportes.pesv">
				<template #header>
				<div class="rp-tab-header">
					<i class="pi pi-file-pdf"></i> Documento PESV
				</div>
				</template>

				<div class="rp-tab-content">
				<!-- Selector de tipo de filtro -->
				<div class="rp-section-label">
					<i class="pi pi-filter"></i> Tipo de búsqueda
				</div>
				<div class="rp-radio-group">
					<label :class="['rp-radio-card', tipo_filtro == 0 ? 'rp-radio-card--on' : '']"
						@click="tipo_filtro = 0">
					<RadioButton :value="0" v-model="tipo_filtro" />
					<div class="rp-radio-body">
						<div class="rp-radio-icon" style="background:#eff6ff">
						<i class="pi pi-hashtag" style="color:#1e40af"></i>
						</div>
						<div>
						<div class="rp-radio-title">Referencia externa</div>
						<div class="rp-radio-sub">Buscar por referencia específica</div>
						</div>
					</div>
					</label>
					<label :class="['rp-radio-card', tipo_filtro == 1 ? 'rp-radio-card--on' : '']"
						@click="tipo_filtro = 1">
					<RadioButton :value="1" v-model="tipo_filtro" />
					<div class="rp-radio-body">
						<div class="rp-radio-icon" style="background:#f0fdf4">
						<i class="pi pi-calendar" style="color:#166534"></i>
						</div>
						<div>
						<div class="rp-radio-title">Rango de fecha</div>
						<div class="rp-radio-sub">Filtrar por periodo</div>
						</div>
					</div>
					</label>
				</div>

				<!-- Filtro por referencia externa -->
				<template v-if="tipo_filtro == 0">
					<div class="rp-section-label" style="margin-top:1rem">
					<i class="pi pi-search"></i> Referencia externa
					</div>
					<div class="rp-form-field">
					<label>Ingrese la referencia externa</label>
					<InputText type="text" v-model="referencia_externa"
						placeholder="Ej: REF-001"
						:class="{'p-invalid': submitted && !referencia_externa}" />
					</div>
					<button class="rp-btn-primary rp-btn-full" @click="buscar_datos_vehiculo"
							:disabled="loader">
					<i class="pi pi-search"></i>
					{{ loader ? 'Buscando…' : 'Buscar movimiento' }}
					</button>

					<template v-if="IdCustomer != ''">
					<div class="rp-vehiculo-card">
						<div class="rp-vehiculo-icon">
						<i class="pi pi-truck"></i>
						</div>
						<div class="rp-vehiculo-info">
						<div class="rp-vehiculo-placa">{{ datos_vehiculo.placa }}</div>
						<div class="rp-vehiculo-marca">{{ datos_vehiculo.marca }}</div>
						</div>
					</div>
					<div class="rp-section-label">
						<i class="pi pi-download"></i> Formato de descarga
					</div>
					<div class="rp-formato-btns">
						<button class="rp-btn-formato" @click="downloadPreoperacional('pdf')"
								:disabled="loader">
						<i class="pi pi-file-pdf" style="color:#dc2626"></i> PDF
						</button>
						<button class="rp-btn-formato" @click="downloadPreoperacional('xlsx')"
								:disabled="loader">
						<i class="pi pi-file-excel" style="color:#166534"></i> XLSX
						</button>
						<button class="rp-btn-formato" @click="downloadPreoperacional('csv')"
								:disabled="loader">
						<i class="pi pi-file" style="color:#1e40af"></i> CSV
						</button>
					</div>
					</template>
				</template>

				<!-- Filtro por rango de fecha -->
				<template v-if="tipo_filtro == 1">
					<div class="rp-section-label" style="margin-top:1rem">
					<i class="pi pi-calendar-range"></i> Rango de fechas
					</div>
					<div class="rp-date-grid">
					<div class="rp-form-field">
						<label>Fecha inicio</label>
						<Calendar v-model="fecha" :showButtonBar="true" :showIcon="true"
						:locale="$primevue.config.locale"
						:class="{'p-invalid': submitted && !fecha}" />
					</div>
					<div class="rp-form-field">
						<label>Fecha fin</label>
						<Calendar v-model="fecha_fin" :showButtonBar="true" :showIcon="true"
						:locale="$primevue.config.locale"
						:class="{'p-invalid': submitted && !fecha_fin}" />
					</div>
					</div>
					<div class="rp-section-label" style="margin-top:.75rem">
					<i class="pi pi-download"></i> Formato de descarga
					</div>
					<div class="rp-formato-btns">
					<button class="rp-btn-formato" @click="downloadPreoperacionalRangoPdf('pdf')"
							:disabled="loader">
						<i class="pi pi-file-pdf" style="color:#dc2626"></i> PDF
					</button>
					<button class="rp-btn-formato" @click="downloadPreoperacionalRango('xlsx')"
							:disabled="loader">
						<i class="pi pi-file-excel" style="color:#166534"></i> XLSX
					</button>
					<button class="rp-btn-formato" @click="downloadPreoperacionalRango('csv')"
							:disabled="loader">
						<i class="pi pi-file" style="color:#1e40af"></i> CSV
					</button>
					</div>
				</template>
				</div>
			</TabPanel>

			<!-- ── Tab Movimientos Sincronizados ── -->
			<TabPanel v-if="opcionesReportes.mov">
				<template #header>
				<div class="rp-tab-header">
					<i class="pi pi-truck"></i> Movimientos Sincronizados
				</div>
				</template>

				<div class="rp-tab-content">
				<div class="rp-section-label">
					<i class="pi pi-calendar-range"></i> Rango de fechas
				</div>
				<div class="rp-date-grid">
					<div class="rp-form-field">
					<label>Fecha inicio</label>
					<Calendar v-model="fecha" :showButtonBar="true" :showIcon="true"
						:locale="$primevue.config.locale"
						:class="{'p-invalid': submitted && !fecha}" />
					</div>
					<div class="rp-form-field">
					<label>Fecha fin</label>
					<Calendar v-model="fecha_fin" :showButtonBar="true" :showIcon="true"
						:locale="$primevue.config.locale"
						:class="{'p-invalid': submitted && !fecha_fin}" />
					</div>
				</div>

				<div class="rp-section-label" style="margin-top:.875rem">
					<i class="pi pi-file"></i> Formato del archivo
				</div>
				<div class="rp-formato-radio">
					<label :class="['rp-formato-opt', formato_archivo == 'xlsx' ? 'rp-formato-opt--on' : '']"
						@click="formato_archivo = 'xlsx'">
					<RadioButton value="xlsx" v-model="formato_archivo" />
					<i class="pi pi-file-excel" style="color:#166534"></i>
					XLSX
					</label>
					<label :class="['rp-formato-opt', formato_archivo == 'csv' ? 'rp-formato-opt--on' : '']"
						@click="formato_archivo = 'csv'">
					<RadioButton value="csv" v-model="formato_archivo" />
					<i class="pi pi-file"></i>
					CSV
					</label>
				</div>

				<button class="rp-btn-primary rp-btn-full" style="margin-top:1rem"
						@click="downloadMovimientos" :disabled="loader">
					<i class="pi pi-download"></i>
					{{ loader ? 'Generando…' : 'Descargar movimientos' }}
				</button>
				</div>
			</TabPanel>

			<!-- ── Tab Tiempos Logísticos ── -->
			<TabPanel v-if="opcionesReportes.time_log">
				<template #header>
				<div class="rp-tab-header">
					<i class="pi pi-clock"></i> Tiempos Logísticos
				</div>
				</template>

				<div class="rp-tab-content">
				<div class="rp-section-label">
					<i class="pi pi-calendar-range"></i> Rango de fechas
				</div>
				<div class="rp-date-grid">
					<div class="rp-form-field">
					<label>Fecha inicio</label>
					<Calendar v-model="fecha" :showButtonBar="true" :showIcon="true"
						:locale="$primevue.config.locale"
						:class="{'p-invalid': submitted && !fecha}" />
					</div>
					<div class="rp-form-field">
					<label>Fecha fin</label>
					<Calendar v-model="fecha_fin" :showButtonBar="true" :showIcon="true"
						:locale="$primevue.config.locale"
						:class="{'p-invalid': submitted && !fecha_fin}" />
					</div>
				</div>

				<div class="rp-section-label" style="margin-top:.875rem">
					<i class="pi pi-file"></i> Formato del archivo
				</div>
				<div class="rp-formato-radio">
					<label :class="['rp-formato-opt', formato_archivo == 'xlsx' ? 'rp-formato-opt--on' : '']"
						@click="formato_archivo = 'xlsx'">
					<RadioButton value="xlsx" v-model="formato_archivo" />
					<i class="pi pi-file-excel" style="color:#166534"></i>
					XLSX
					</label>
					<label :class="['rp-formato-opt', formato_archivo == 'csv' ? 'rp-formato-opt--on' : '']"
						@click="formato_archivo = 'csv'">
					<RadioButton value="csv" v-model="formato_archivo" />
					<i class="pi pi-file"></i>
					CSV
					</label>
				</div>

				<button class="rp-btn-primary rp-btn-full" style="margin-top:1rem"
						@click="downloadTiemposLogisticos" :disabled="loader">
					<i class="pi pi-download"></i>
					{{ loader ? 'Generando…' : 'Descargar tiempos logísticos' }}
				</button>
				</div>
			</TabPanel>

			</TabView>
		</div>

		<template #footer>
			<button class="rp-btn-outline" @click="ModalReport = false">
			<i class="pi pi-times"></i> Cerrar
			</button>
		</template>
		</Dialog>
	</div>
</template>

<script>
import AppConfig from './AppConfig.vue';
import AppTopBar from './AppTopbar.vue';
import AppInlineMenu from './AppInlineMenu.vue';
import AppMenu from './AppMenu.vue';
import AppFooter from './AppFooter.vue';
import EventBus from './event-bus';
import { APIENDPOINTIMG } from './app.config'

export default {
	emits: ['layout-mode-change', 'menu-theme', 'menuTheme', 'topbar-theme', 'topbarTheme', 'layoutModeChange'],
	props: {
		topbarTheme: String,
		menuTheme: String,
		layoutMode: String
	},
    data() {
        return {
			SupAdm: null,
			SerCon: null,
			menu: [],
			modulosDisponibles: [],
			permisos_detallados: [],
			nombre: '',
			opcionesReportes: {
				pesv: false,
				mov: false,
				time_log: false
			},
			reporte_customers_group: [],
			reporte_customer_selected: null,
			cargo: '',
			img_profile: '',
			d_topbarTheme: this.topbarTheme,
			d_menuTheme: this.menuTheme,
			d_layoutMode: this.layoutMode,
			mobileTopbarActive: false,
			mobileMenuActive: false,
			search: false,
			searchClick: false,
			searchActive: false,
			menuMode: 'static',
			inlineMenuClick: false,
			inlineMenuPosition: 'bottom',
			inlineMenuTopActive: false,
			inlineMenuBottomActive: false,
			overlayMenuActive: false,
			rotateMenuButton: false,
			loader: false,
			topbarMenuActive: false,
			submitted: false,
			activeTopbarItem: null,
			isSlimOrHorItemClick: false,
			darkMenu: false,
			theme: 'blue',
			themes: [
				{name: 'indigo', color: '#2f8ee5'},
				{name: 'pink', color: '#E91E63'},
				{name: 'purple', color: '#9C27B0'},
				{name: 'deeppurple', color: '#673AB7'},
				{name: 'blue', color: '#2196F3'},
				{name: 'lightblue', color: '#03A9F4'},
				{name: 'cyan', color: '#00BCD4'},
				{name: 'teal', color: '#009688'},
				{name: 'green', color: '#4CAF50'},
				{name: 'lightgreen', color: '#8BC34A'},
				{name: 'lime', color: '#CDDC39'},
				{name: 'yellow', color: '#FFEB3B'},
				{name: 'amber', color: '#FFC107'},
				{name: 'orange', color: '#FF9800'},
				{name: 'deeporange', color: '#FF5722'},
				{name: 'sewayblue', color: '#0A354E'},
				{name: 'brown', color: '#795548'},
				{name: 'bluegrey', color: '#607D8B'}
			],
			menuThemes: [
				{name: 'light', color: '#FDFEFF'},
				{name: 'dark', color: '#434B54'},
				{name: 'indigo', color: '#1A237E'},
				{name: 'sewayblue', color: '#0A354E'},
				{name: 'bluegrey', color: '#37474F'},
				{name: 'brown', color: '#4E342E'},
				{name: 'cyan', color: '#006064'},
				{name: 'green', color: '#2E7D32'},
				{name: 'deeppurple', color: '#4527A0'},
				{name: 'deeporange', color: '#BF360C'},
				{name: 'pink', color: '#880E4F'},
				{name: 'purple', color: '#6A1B9A'},
				{name: 'teal', color: '#00695C'}
			],
			topbarThemes: [
				{name: 'lightblue', color: '#2E88FF'},
				{name: 'sewayblue', color: '#0A354E'},
				{name: 'dark', color: '#363636'},
				{name: 'white', color: '#FDFEFF'},
				{name: 'blue', color: '#1565C0'},
				{name: 'deeppurple', color: '#4527A0'},
				{name: 'purple', color: '#6A1B9A'},
				{name: 'pink', color: '#AD1457'},
				{name: 'cyan', color: '#0097A7'},
				{name: 'teal', color: '#00796B'},
				{name: 'green', color: '#43A047'},
				{name: 'lightgreen', color: '#689F38'},
				{name: 'lime', color: '#AFB42B'},
				{name: 'yellow', color: '#FBC02D'},
				{name: 'amber', color: '#FFA000'},
				{name: 'orange', color: '#FB8C00'},
				{name: 'deeporange', color: '#D84315'},
				{name: 'brown', color: '#5D4037'},
				{name: 'grey', color: '#616161'},
				{name: 'bluegrey', color: '#546E7A'},
				{name: 'indigo', color: '#3F51B5'}
			],
			rightPanelActive: false,
			menuActive: true,
			ModalReport: false,
			num_movimiento: '',
			datos_vehiculo: [],
			viaje: {},
			IdCustomer: '',
			fecha: '',
			fecha_fin: '',
			formato_archivo: 'xlsx',
			tipo_filtro: 0,
            menu_especiales: [
				{label: 'Inicio', icon: 'pi pi-fw pi-home', to: this.$store.getters['infoNavigation/Rol']+'/inicio'},
				{
					label: 'Maestros', icon: 'pi pi-fw pi-briefcase',
					items: [
						{label: 'Funcionarios', icon: 'pi pi-fw pi-users', to: this.$store.getters['infoNavigation/Rol']+'/funcionarios'},
						{label: 'Orígenes y Destinos', icon: 'pi pi-fw pi-map-marker', to: this.$store.getters['infoNavigation/Rol']+'/origenes-destinos'},
						{label: 'Centros de costos', icon: 'pi pi-fw pi-money-bill', to: this.$store.getters['infoNavigation/Rol']+'/centros-costos'},
					]
				},
				{
					label: 'Servicios', icon: 'pi pi-fw pi-briefcase',
					items: [
						{label: 'Solicitudes transporte especial', icon: 'pi pi-fw pi-car', to: this.$store.getters['infoNavigation/Rol']+'/solicitudes-transporte-especial'},
					]
				}
            ],
			menu_generadores: [
				{
					label: '', 
					icon: 'pi pi-fw pi-home',
					items: [
						{label: 'Inicio', icon: 'pi pi-fw pi-home', to: this.$store.getters['infoNavigation/Rol']+'/'}
					]
				},
				// {
				// 	label: 'Contable', icon: 'pi pi-fw pi-wallet',
				// 	items: [
				// 		{label: 'Cartera', icon: 'pi pi-fw pi-money-bill', to: this.$store.getters['infoNavigation/Rol']+'/pendientes'},
				// 		{label: 'Historial de Facturación', icon: 'pi pi-fw pi-history	', to: this.$store.getters['infoNavigation/Rol']+'/ventas'}
				// 	]
				// },
				{
					label: '', icon: 'pi pi-fw pi-sitemap',
					items: [
						{
							label: 'Movimientos', icon: 'pi pi-fw pi-sitemap',
							items: [
								{label: 'Viajes', icon: 'pi pi-truck', to: this.$store.getters['infoNavigation/Rol']+'/viajes'},
								// {label: 'Informe de Detalles', icon: 'pi pi-list', to: this.$store.getters['infoNavigation/Rol']+'/info-detalles'}
							]
						}
					]
				},
				{
					label: '', icon: 'pi pi-fw pi-sitemap',
					items: [
						{
							label: 'Recursos', icon: 'pi pi-fw pi-globe',
							items: [
								{label: 'Terceros',icon: 'pi pi-fw pi-users',to: this.$store.getters['infoNavigation/Rol'] + '/hv-conductores'},
								{label: 'Vehículos', icon: 'pi pi-fw pi-truck', to: this.$store.getters['infoNavigation/Rol']+'/hv-vehiculos'}
							]
						}
					]
				},
				{
					label: '',
					icon: 'pi pi-fw pi-file-pdf',
					items: [
						{label: 'Reportes', icon: 'pi pi-fw pi-file-pdf', command:() => { this.click_report(); }}
					]
				},
				{
					label: '',
					icon: 'pi pi-fw pi-cog',
					items: [
						{
							label: 'Configuraciones', icon: 'pi pi-fw pi-cog',
							items: [
								{
									label: 'Conectores', icon: 'pi pi-fw pi-share-alt',
									items: [
										{label: 'Webhooks', icon: 'pi pi-fw pi-bolt', to: this.$store.getters['infoNavigation/Rol'] + '/configuracion/webhooks'}
									]
								}
							]
						}
					]
				},
            ],
			menu_empresa_transporte_adm: [
				{
					label: '', 
					icon: 'pi pi-fw pi-home',
					items: [
						{label: 'Inicio', icon: 'pi pi-fw pi-home', to: this.$store.getters['infoNavigation/Rol']+'/'}
					]
				},
				{
					label: '', icon: 'pi pi-fw pi-sitemap',
					items: [
						{
							label: 'Movimientos', icon: 'pi pi-fw pi-sitemap',
							items: [
								{label: 'Movimientos APP', icon: 'pi pi-fw pi-truck', to: this.$store.getters['infoNavigation/Rol']+'/viajes'},
								{label: 'Legalización Gastos', icon: 'pi pi-fw pi-wallet', to: this.$store.getters['infoNavigation/Rol']+'/legalizacion-gastos'}
							]
						}
					]
				},
				{
					label: '', icon: 'pi pi-fw pi-wallet',
					items: [
						{
							label: 'Contable', icon: 'pi pi-fw pi-wallet',
							items: [
								{label: 'Cartera', icon: 'pi pi-fw pi-wallet', to: this.$store.getters['infoNavigation/Rol']+'/pendientes'}
							]
						}
					]
				},
				{
					label: '', 
					icon: 'pi pi-fw pi-file-pdf',
					items: [
						{label: 'Reportes', icon: 'pi pi-fw pi-file-pdf', command:() => { this.click_report(); }}
					]
				},
				{
					items: [
						{
							label: 'Configuraciones', icon: 'pi pi-fw pi-cog',
							items: [
								{
									label: 'Administración', icon: 'pi pi-fw pi-desktop',
									items: [
										{label: 'Usuarios', icon: 'pi pi-fw pi-users', to: this.$store.getters['infoNavigation/Rol']+'/configuracion/admin-usuarios'},
										{label: 'Perfiles', icon: 'pi pi-fw pi-bookmark-fill', to: this.$store.getters['infoNavigation/Rol']+'/configuracion/perfiles'},
									]
								},
								{
									label: 'Mobile', icon: 'pi pi-fw pi-mobile',
									items: [
										{label: 'Conductores', icon: 'pi pi-fw pi-users', to: this.$store.getters['infoNavigation/Rol']+'/configuracion/usuarios'},
										{label: 'Eventos Logisticos', icon: 'pi pi-fw pi-history', to: this.$store.getters['infoNavigation/Rol']+'/configuracion/eventos'},
										{label: 'Pre Operacional', icon: 'pi pi-fw pi-calendar', to: this.$store.getters['infoNavigation/Rol']+'/configuracion/pesv'},
										{label: 'Tipo Gastos', icon: 'pi pi-fw pi-wallet', to: this.$store.getters['infoNavigation/Rol']+'/configuracion/tipo-gastos'},
									]
								},
								{
									label: 'RNDC', icon: 'pi pi-fw pi-sitemap',
									items: [
										{label: 'Terceros', icon: 'pi pi-fw pi-users', to: this.$store.getters['infoNavigation/Rol']+'/configuracion/terceros'},
										{label: 'Vehiculos', icon: 'pi pi-fw pi-truck', to: this.$store.getters['infoNavigation/Rol']+'/configuracion/vehiculos'},
									]
								},
							]
						}
					]
				},
				
            ],
			menu_empresa_transporte: [
				{
					label: '', 
					icon: 'pi pi-fw pi-home',
					items: [
						{label: 'Inicio', icon: 'pi pi-fw pi-home', to: this.$store.getters['infoNavigation/Rol']+'/'}
					]
				},
				{
					label: '', icon: 'pi pi-fw pi-sitemap',
					items: [
						{
							label: 'Movimientos', icon: 'pi pi-fw pi-sitemap',
							items: [
								{label: 'Movimientos APP', icon: 'pi pi-fw pi-truck', to: this.$store.getters['infoNavigation/Rol']+'/viajes'},
								{label: 'Viajes Sincronizados', icon: 'pi pi-fw pi-truck', to: this.$store.getters['infoNavigation/Rol']+'/viajes-seway'},
								{label: 'Legalización Gastos', icon: 'pi pi-fw pi-wallet', to: this.$store.getters['infoNavigation/Rol']+'/legalizacion-gastos'}
							]
						}
					]
				},
				{
					label: '', icon: 'pi pi-fw pi-wallet',
					items: [
						{
							label: 'Contable', icon: 'pi pi-fw pi-wallet',
							items: [
								{label: 'Cartera', icon: 'pi pi-fw pi-wallet', to: this.$store.getters['infoNavigation/Rol']+'/pendientes'}
							]
						}
					]
				},
				{
					label: '', 
					icon: 'pi pi-fw pi-file-pdf',
					items: [
						{label: 'Reportes', icon: 'pi pi-fw pi-file-pdf', command:() => { this.click_report(); }}
					]
				},
            ],
			menuBaseEmpresaTransporte: [
				{
					label: '',
					icon: 'pi pi-fw pi-home',
					items: [
						{ 
							label: 'Inicio', 
							icon: 'pi pi-fw pi-home', 
							to: this.$store.getters['infoNavigation/Rol'] + '/' 
						}
					]
				},
				{
					label: '',
					icon: 'pi pi-fw pi-sitemap',
					items: [
						{
							label: 'Movimientos',
							icon: 'pi pi-fw pi-sitemap',
							items: [
								{
									key: 'mov_app_1',
									label: 'Movimientos APP',
									icon: 'pi pi-fw pi-truck',
									to: this.$store.getters['infoNavigation/Rol'] + '/viajes'
								},
								{
									key: 'mov_app_2',
									label: 'Viajes Sincronizados',
									icon: 'pi pi-fw pi-truck',
									to: this.$store.getters['infoNavigation/Rol'] + '/viajes-seway'
								}
							]
						}
					]
				},
				{
					label: '',
					icon: 'pi pi-fw pi-wallet',
					items: [
						{
							label: 'Contable',
							icon: 'pi pi-fw pi-wallet',
							items: [
								{
									label: 'Cartera',
									icon: 'pi pi-fw pi-wallet',
									to: this.$store.getters['infoNavigation/Rol'] + '/pendientes'
								},
								{
									label: 'Legalización Gastos',
									icon: 'pi pi-fw pi-wallet',
									to: this.$store.getters['infoNavigation/Rol'] + '/legalizacion-gastos'
								}
							]
						}
					]
				},
				{
					label: '',
					icon: 'pi pi-fw pi-file-pdf',
					items: [
						{
							label: 'Reportes',
							icon: 'pi pi-fw pi-file-pdf',
							command:() => { this.click_report(); }
						}
					]
				},
				{
					items: [
						{
							label: 'Configuraciones', icon: 'pi pi-fw pi-cog',
							items: [
								{
									label: 'Mobile', icon: 'pi pi-fw pi-mobile',
									items: [
										{label: 'Conductores', icon: 'pi pi-fw pi-users', to: this.$store.getters['infoNavigation/Rol']+'/configuracion/usuarios'},
										{label: 'Eventos Logisticos', icon: 'pi pi-fw pi-history', to: this.$store.getters['infoNavigation/Rol']+'/configuracion/eventos'},
										{label: 'Pre Operacional', icon: 'pi pi-fw pi-calendar', to: this.$store.getters['infoNavigation/Rol']+'/configuracion/pesv'},
										{label: 'Tipo Gastos', icon: 'pi pi-fw pi-wallet', to: this.$store.getters['infoNavigation/Rol']+'/configuracion/tipo-gastos'},
									]
								},
								{
									label: 'RNDC', icon: 'pi pi-fw pi-sitemap',
									items: [
										{label: 'Terceros', icon: 'pi pi-fw pi-users', to: this.$store.getters['infoNavigation/Rol']+'/configuracion/terceros'},
										{label: 'Vehiculos', icon: 'pi pi-fw pi-truck', to: this.$store.getters['infoNavigation/Rol']+'/configuracion/vehiculos'},
									]
								},
							]
						}
					]
				},
			],
			menu_super_admin: [
				{label: 'Inicio', icon: 'pi pi-fw pi-home', to: this.$store.getters['infoNavigation/Rol']+'/inicio'},
				{label: 'Clientes', icon: 'pi pi-fw pi-database', to: this.$store.getters['infoNavigation/Rol']+'/clientes'},
				{label: 'Usuarios', icon: 'pi pi-fw pi-database', to: this.$store.getters['infoNavigation/Rol']+'/usuarios'}
            ],
			menu_super_admin2: [
				{label: 'Inicio', icon: 'pi pi-fw pi-home', to: this.$store.getters['infoNavigation/Rol']+'/inicio'},
				{
					label: 'Administrar', icon: 'pi pi-sitemap',
					items: [
						{label: 'Clientes', icon: 'pi pi-fw pi-database', to: this.$store.getters['infoNavigation/Rol']+'/clientes'},
						{label: 'Usuarios', icon: 'pi pi-fw pi-database', to: this.$store.getters['infoNavigation/Rol']+'/usuarios'}
					]
				},
            ],
			items: [
                {
                    label: 'PDF',
                    icon: 'pi pi-file-pdf',
					command: () => {
                        this.downloadPreoperacional('pdf');
                    }
                },
                {
                    label: 'XLSX',
                    icon: 'pi pi-file-excel',
					command: () => {
                        this.downloadPreoperacional('xlsx');
                    }
                },
                {
                    label: 'CSV',
                    icon: 'pi pi-file-excel',
					command: () => {
                        this.downloadPreoperacional('csv');
                    }
                }
            ],
			items_rango: [
                {
                    label: 'PDF',
                    icon: 'pi pi-file-pdf',
					command: () => {
                        this.downloadPreoperacionalRangoPdf('pdf');
                    }
                },
                {
                    label: 'XLSX',
                    icon: 'pi pi-file-excel',
					command: () => {
                        this.downloadPreoperacionalRango('xlsx');
                    }
                },
                {
                    label: 'CSV',
                    icon: 'pi pi-file-excel',
					command: () => {
                        this.downloadPreoperacionalRango('csv');
                    }
                }
            ],
        }
    },
	created(){
		EventBus.on('on-loader', () => this.onspinner());
		EventBus.on('off-loader', () => this.offspinner());
		EventBus.on('on-notification', (message) => this.showAlert(message));
		
	},
	async mounted(){
		// this.cargar_infoCustomer();
		// console.log(this.$store.getters['infoNavigation/IdRol']);
		const SupAdm = 'SupAdm';
		const SerCon = 'SerCon';
		const cookieName = 'Nombre';
		const id_rol = 'IdRol';
		const ImgUser = 'ImgUser';
		let cookie = {};
			document.cookie.split(';').forEach(function(el) {
			let [key,value] = el.split('=');
			cookie[key.trim()] = value;
			})
		this.SupAdm = cookie[SupAdm];
		this.SerCon = cookie[SerCon];
		this.nombre = cookie[cookieName];
		if(cookie[id_rol] == 1){
			this.cargo = 'Especiales';
		}else if(cookie[id_rol] == 2){
			this.cargo = 'Generador';
		}else if(cookie[id_rol] == 5){
			this.cargo = 'Empresa de Transporte';
		}else if(cookie[id_rol] == 6){
			this.cargo = 'Super Administrador';
		}
		if(cookie[ImgUser]=='null'){
			this.img_profile = APIENDPOINTIMG+'img_profiles/profile.jpg';
		}else{
			this.img_profile = APIENDPOINTIMG+'img_profiles/'+cookie[ImgUser];
		}

		// Cargar menú inicial (solo inicio mientras carga)
        this.menu = [this.menuBaseEmpresaTransporte[0]];
        
        //  Escuchar permisos desde el router
        EventBus.on('actualizar-menu-permisos', (permisos, permisos_detallados) => {
			// Si ya sabemos que es superadmin, no sobreescribir con datos vacíos
			if (this.permisos_detallados === 'all' && permisos_detallados !== 'all') return;
			
			this.modulosDisponibles  = permisos || [];
			this.permisos_detallados = permisos_detallados ?? [];
			this.construirMenu();
		});
        
        // Cargar permisos iniciales
        await this.cargarPermisosIniciales();

	},
	beforeUnmount() {
        // Limpiar listener
        EventBus.off('actualizar-menu-permisos');
    },
    watch: {
        $route() {
			this.menuActive = this.isStatic() && !this.isMobile();
            this.$toast.removeAllGroups();
        },
		topbarTheme(newValue) {
			this.d_topbarTheme = newValue;
		},
		menuTheme(newValue) {
			this.d_menuTheme = newValue;
		},
		layoutMode(newValue) {
			this.d_layoutMode = newValue;
		}
    },
    methods: {
		toggle(event) {
            this.$refs.menu.toggle(event);
        },
		toggle_rango(event) {
            this.$refs.menu.toggle(event);
        },
		click_report(){
			this.loader = true;
			var _that = this;
			let cookie = {};
			document.cookie.split(';').forEach(function(el) {
				let [key,value] = el.split('=');
				cookie[key.trim()] = value;
			});
			var email = cookie['Email'];
			var id_rol = cookie['IdRol'];

			_that.reporte_customers_group = [];
			_that.reporte_customer_selected = null;

			window.api.call('post', '/consultar_opciones_reportes', {email: email, id_rol: id_rol}).then( function(response) {
                    if(response.status == 200){
						_that.opcionesReportes = response.data.data;
						_that.ModalReport = true;
						_that.datos_vehiculo = [];
						_that.viaje = {};
						_that.IdCustomer = '';

						// Generador puede trabajar con varias transportadoras: se pide
						// seleccionar la empresa antes de habilitar la descarga, igual
						// que en el módulo Viajes (generador/Viajes.vue).
						if (id_rol == 2) {
							window.api.call('post', '/cargar_customers?&page=1', {email: email, id_rol: id_rol}).then(function (resp) {
								if (resp.status == 200) {
									_that.reporte_customers_group = resp.data.data;
									if (resp.data.data.length == 1) {
										_that.reporte_customer_selected = resp.data.data[0].id_customer;
									}
								}
								_that.loader = false;
							}).catch(function (err) {
								console.log(err);
								_that.loader = false;
							});
						} else {
							_that.loader = false;
						}
                    }
                }).catch(function (err) {
                    console.log(err);
					_that.loader = false;
                });
		},
		buscar_datos_vehiculo(){
			if (this.tipo_filtro==0) {
				if(this.num_movimiento=='' || this.num_movimiento==0){
					this.submitted = true;
					this.$toast.add({severity:'error', summary: 'Número de Movimiento Vacio!', detail:'Favor ingresar un número de mov', life: 4000});
					return
				}
			}
			if (this.tipo_filtro==1) {
				if(this.fecha=='' || this.fecha_fin==''){
					// console.log(this.text_filter);
					this.$toast.add({severity:'error', summary: 'Falta información', detail:'Favor seleccionar una fecha inicio y una fecha fin a filtrar (rando de 30 dias!)', life: 4000});
					return;
				}
			}
			

			this.loader = true;
			// console.log('si diooooj mioo');
			const cookieName = 'Email';
			const IdRol = 'IdRol';
			let cookie = {};
			document.cookie.split(';').forEach(function(el) {
			let [key,value] = el.split('=');
			cookie[key.trim()] = value;
			})
			var email = cookie[cookieName];
			var id_rol = cookie[IdRol];
			var _that = this;
			this.datos_vehiculo = [];
			this.viaje = {};
			this.IdCustomer = '';
			window.api.call('post', '/buscar_datos_vehiculo', {email: email,id_rol: id_rol,num_movimiento: this.num_movimiento,fecha: this.fecha,fecha_fin: this.fecha_fin,tipo_filtro: this.tipo_filtro}).then( function(response) {
				if(response.status == 200){
					if (_that.tipo_filtro==0) {
						_that.datos_vehiculo = response.data.datos_vehiculo;
						_that.viaje = response.data.viaje;
					}
					if (_that.tipo_filtro==1) {
						var nombrearchivo = 'Informe pre operacional.xlsx';
						// var nombrearchivo = this.datos_vehiculo.placa+'.'+formato;
						_that.forceFileDownloadQr(response,nombrearchivo);
					}
					_that.IdCustomer = response.data.id_customer;
					_that.loader = false;
				}
			}).catch(function (err) {
				console.log(err);
				_that.loader = false;
				if (err.status==422) {
					_that.$toast.add({severity:'error', summary: 'Ocurrio un error al buscar', detail:err.data.data, life: 6000});
				}
				if(err.status==423){

					_that.$toast.add({severity:'error', summary: 'Error', detail:'El rango de fechas no puede ser superior a 30 días.', life: 6000});
				}
				if(err.status==414){
					_that.$toast.add({severity:'warn', summary: 'Falta información', detail:'No se encuentra preoperativos en este rango', life: 4000});
				}
				if(err.status==415){
					_that.$toast.add({severity:'warn', summary: 'Falta información', detail:'No se encuentra configuración de su preoperacional', life: 4000});
				}
				
			});
		},
		async downloadPreoperacionalRango(formato){
			
			if (this.tipo_filtro==1) {
				if(this.fecha=='' || this.fecha_fin==''){
					// console.log(this.text_filter);
					this.$toast.add({severity:'error', summary: 'Falta información', detail:'Favor seleccionar una fecha inicio y una fecha fin a filtrar (rando de 30 dias!)', life: 4000});
					return;
				}
			}
			this.loader = true;
            var _that = this;
			const cookieName = 'Email';
			const IdRol = 'IdRol';
			let cookie = {};
			document.cookie.split(';').forEach(function(el) {
			let [key,value] = el.split('=');
			cookie[key.trim()] = value;
			})
			var email = cookie[cookieName];
			var id_rol = cookie[IdRol];
            axios({
            url: '/buscar_datos_vehiculo',
            method: 'POST',
            data: {email: email,id_rol: id_rol,num_movimiento: this.num_movimiento,fecha: this.fecha,fecha_fin: this.fecha_fin,tipo_filtro: this.tipo_filtro,formato: formato},
            responseType: 'blob',
            }).then((response) => {
				// if (formato=='PDF') {
				// 	console.log(response.data.data);
					
				// }else{
					var nombrearchivo = 'Informe pre operacional.'+formato;
					_that.forceFileDownloadQr(response,nombrearchivo);
				// }
				
				_that.loader = false;
            }).catch((error) => {
				_that.loader = false;
				if (error.response){
					if (error.response.status==414) {
						_that.$toast.add({severity:'warn', summary: 'Falta información', detail:'No se encuentra preoperativo de este viaje', life: 4000});
					}
					if (error.response.status==423) {
						_that.$toast.add({severity:'warn', summary: 'Falta información', detail:'El rango de fechas no puede ser superior a 30 días', life: 4000});
					}
					if (error.response.status>=500) {
						_that.$toast.add({severity:'warn', summary: 'Ocurrio un Error', detail:'El proceso se ha cancelado por un error en el servidor', life: 4000});
					}
				}
			});
        },
		async downloadPreoperacionalRangoPdf(formato){
			
			if (this.tipo_filtro==1) {
				if(this.fecha=='' || this.fecha_fin==''){
					// console.log(this.text_filter);
					this.$toast.add({severity:'error', summary: 'Falta información', detail:'Favor seleccionar una fecha inicio y una fecha fin a filtrar (rando de 30 dias!)', life: 4000});
					return;
				}
			}
			this.loader = true;
            var _that = this;
			const cookieName = 'Email';
			const IdRol = 'IdRol';
			let cookie = {};
			document.cookie.split(';').forEach(function(el) {
			let [key,value] = el.split('=');
			cookie[key.trim()] = value;
			})
			var email = cookie[cookieName];
			var id_rol = cookie[IdRol];
            axios({
            url: '/buscar_datos_vehiculo',
            method: 'POST',
            data: {email: email,id_rol: id_rol,num_movimiento: this.num_movimiento,fecha: this.fecha,fecha_fin: this.fecha_fin,tipo_filtro: this.tipo_filtro,formato: formato},
            // responseType: 'blob',
            }).then((response) => {
				const rawData = response.data?.data ?? [];

				// Si no hay nada
				if (!Array.isArray(rawData) || rawData.length === 0) {
					const newWindow = window.open("", "_blank");
					newWindow.document.write("<p>No hay datos para mostrar.</p>");
					newWindow.document.close();
					_that.loader = false;
					return;
				}

				// ── Helpers ──────────────────────────────────────────────
				const escapeHtml = (s) => {
					if (s === null || s === undefined) return "";
					return String(s)
						.replace(/&/g, "&amp;")
						.replace(/</g, "&lt;")
						.replace(/>/g, "&gt;")
						.replace(/"/g, "&quot;")
						.replace(/'/g, "&#039;");
				};

				const normalizeUrl = (url) => {
					if (!url) return "";
					if (url.startsWith("http://") || url.startsWith("https://")) return url;
					const origin = window.location.origin;
					return origin + (url.startsWith("/") ? url : "/" + url);
				};

				const fmtFecha = (d) => {
					const dt = new Date(d);
					if (isNaN(dt)) return "";
					const pad = (n) => String(n).padStart(2, "0");
					return `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(dt.getDate())} ${pad(dt.getHours())}:${pad(dt.getMinutes())}`;
				};

				// ── Sistema de calificación dinámico (mismo esquema que pdf.preoperacional.blade.php) ──
				const buildRateSystem = (registroRate) => {
					const usaRateDinamico = Array.isArray(registroRate) && registroRate.length > 0;
					const esNA = (rr) => {
						const rv = Number(rr.rate);
						const label = String(rr.description ?? rr.tittle ?? "").trim().toLowerCase();
						return rv === 0 || ["n/a", "na", "no aplica", "no apply", "n.a", "no-aplica", "nva", "nv/a"].includes(label);
					};

					let rateMap = {};
					let rateNA = 0;
					let totalV = 5;

					if (usaRateDinamico) {
						const ratesCol = [...registroRate].sort((a, b) => Number(a.rate) - Number(b.rate));
						rateNA = null;
						const validos = [];
						ratesCol.forEach((rr) => {
							const rv = Number(rr.rate);
							if (esNA(rr)) {
								if (rateNA === null) rateNA = rv;
							} else {
								const label = String(rr.description ?? rr.tittle ?? `Rate ${rv}`).trim();
								validos.push({ rate: rv, tittle: label });
							}
						});
						totalV = validos.length;
						validos.forEach((v, pos) => {
							rateMap[v.rate] = { tittle: v.tittle, pos, total: totalV, es_na: false };
						});
						if (rateNA !== null) {
							rateMap[rateNA] = { tittle: "N/A", pos: -1, total: totalV, es_na: true };
						} else {
							rateNA = 0;
						}
					} else {
						rateMap = {
							0: { tittle: "N/A", pos: -1, total: 5, es_na: true },
							1: { tittle: "Muy malo", pos: 0, total: 5, es_na: false },
							2: { tittle: "Malo", pos: 1, total: 5, es_na: false },
							3: { tittle: "Regular", pos: 2, total: 5, es_na: false },
							4: { tittle: "Bueno", pos: 3, total: 5, es_na: false },
							5: { tittle: "Excelente", pos: 4, total: 5, es_na: false },
						};
						rateNA = 0;
						totalV = 5;
					}

					const posMax = totalV - 1;

					const ratio = (r) => {
						const rm = rateMap[r];
						if (!rm || rm.es_na) return -1;
						const total = Math.max(rm.total, 1);
						if (total === 1) return 1;
						return rm.pos / (total - 1);
					};
					const label = (r) => {
						const rm = rateMap[r];
						if (!rm || r === rateNA) return "N/A";
						return rm.tittle || `Rate ${r}`;
					};
					const badge = (r) => {
						const rt = ratio(r);
						if (rt < 0) return "b-na";
						if (rt >= 0.75) return "b-ex";
						if (rt >= 0.50) return "b-ok";
						if (rt >= 0.25) return "b-reg";
						if (rt > 0) return "b-bad";
						return "b-vbad";
					};
					const barColor = (r) => {
						const rt = ratio(r);
						if (rt < 0) return "#aaa";
						if (rt >= 0.50) return "#2e9e4f";
						return rt >= 0.25 ? "#e0a92a" : "#c0392b";
					};
					const esSuficiente = (r) => ratio(r) >= 0.50;

					return { rateMap, rateNA, posMax, ratio, label, badge, barColor, esSuficiente };
				};

				// ── Construye una página de reporte por cada preoperacional ──
				const buildPagina = (item, isLast) => {
					const preoperativo = item.preoperativo || {};
					const categorias = Array.isArray(preoperativo.checklist_categories) ? preoperativo.checklist_categories : [];
					const datosVehiculo = item.datos_vehiculo || {};
					const configPesv = item.configuracion_pesv || {};
					const showCampo = (key) => configPesv[key] === undefined || Number(configPesv[key]) === 1;
					const campoVehiculo = (key, val) => showCampo(key) ? escapeHtml(val ?? "") : "";

					const rs = buildRateSystem(item.registro_rate);

					let totalItems = 0, totalScore = 0, maxScore = 0;
					const hallazgos = [];
					categorias.forEach((cat) => {
						(cat.details || []).forEach((d) => {
							const r = Number(d.rate);
							const rm = rs.rateMap[r];
							if (!rm || rm.es_na) return;
							totalItems++;
							totalScore += rm.pos;
							maxScore += rs.posMax;
							if (!rs.esSuficiente(r)) {
								hallazgos.push({ cat: cat.category_name, item: d.title, rate: r });
							}
						});
					});

					const pct = maxScore > 0 ? Math.round((totalScore / maxScore) * 100) : (totalItems > 0 ? 100 : 0);
					const porRevisar = hallazgos.length;

					const sN = (preoperativo.status !== undefined && preoperativo.status !== null)
						? Number(preoperativo.status)
						: (pct >= 80 ? 2 : 1);
					const bCls = sN === 2 ? "banner-apto" : (sN === 0 ? "banner-no-apto" : "banner-pend");
					const bEye = sN === 2 ? "c-green-dk" : (sN === 0 ? "c-red" : "c-yellow");
					const bStat = sN === 2 ? "APTO" : (sN === 0 ? "NO APTO" : "PENDIENTE");
					const bStC = sN === 2 ? "c-green" : (sN === 0 ? "c-red2" : "c-yellow2");
					const bDesc = sN === 2
						? `El vehículo cumple el ${pct}% de las condiciones y está habilitado para cargar.`
						: (sN === 0
							? escapeHtml(preoperativo.comment || "El vehículo no cumple los requisitos mínimos de seguridad.")
							: "Inspección pendiente de aprobación por el revisor.");

					const pctBad = pct < 80;
					const barW = Math.max(0, Math.min(100, pct));
					const barEmp = 100 - barW;

					const fecha = preoperativo.checklist_general_date || fmtFecha(preoperativo.created_at || Date.now());
					const codigo = item.cod_basc || preoperativo.id_delivery || item.num_movimiento || "";

					// Resumen por categoría
					let resumenHtml = "";
					categorias.forEach((cat) => {
						let catScore = 0, catMax = 0, catCount = 0;
						const catRateCounts = {};
						(cat.details || []).forEach((d) => {
							const r = Number(d.rate);
							const rm = rs.rateMap[r];
							if (!rm || rm.es_na) return;
							catScore += rm.pos;
							catMax += rs.posMax;
							catCount++;
							catRateCounts[r] = (catRateCounts[r] || 0) + 1;
						});

						let catDomRate = rs.rateNA;
						let bw = 0;
						if (catCount > 0) {
							let maxCount = -1;
							Object.keys(catRateCounts).forEach((r) => {
								if (catRateCounts[r] > maxCount) { maxCount = catRateCounts[r]; catDomRate = Number(r); }
							});
							bw = catMax > 0 ? Math.min((catScore / catMax) * 100, 100) : 0;
						}
						const be = 100 - bw;
						const bc = rs.barColor(catDomRate);

						resumenHtml += `
							<table class="cat-tbl" cellpadding="0" cellspacing="0">
								<tr>
									<td class="cat-name-td">${escapeHtml(cat.category_name || "")}</td>
									<td class="cat-bar-td">
										<table width="100%" cellpadding="0" cellspacing="0" style="height:11px;border-radius:5px;overflow:hidden;background:#e0e0e0;">
											<tr>
												${bw > 0 ? `<td style="width:${bw}%;height:11px;background:${bc};"></td>` : ""}
												${be > 0 ? `<td style="width:${be}%;height:11px;background:#e0e0e0;"></td>` : ""}
											</tr>
										</table>
									</td>
									<td class="cat-badge-td"><span class="badge ${rs.badge(catDomRate)}">${escapeHtml(rs.label(catDomRate))}</span></td>
								</tr>
								${cat.category_comment ? `
								<tr>
									<td colspan="3" style="padding:3px 0 4px 2px;font-size:7.5pt;color:#555;font-style:italic;">
										<span style="color:#e07b2a;font-weight:700;font-style:normal;">Obs:</span> ${escapeHtml(cat.category_comment)}
									</td>
								</tr>` : ""}
							</table>
						`;
					});

					// Hallazgos por revisar
					const hallazgosHtml = hallazgos.length === 0
						? `<div class="hall-empty">Sin hallazgos. Todos los ítems en estado óptimo.</div>`
						: hallazgos.map((h) => `
							<table class="hall-tbl" cellpadding="0" cellspacing="0">
								<tr>
									<td class="hall-cat">${escapeHtml(h.cat || "")}</td>
									<td class="hall-name">${escapeHtml(h.item || "")}</td>
									<td class="hall-rate"><span class="badge ${rs.badge(h.rate)}">${escapeHtml(rs.label(h.rate))}</span></td>
								</tr>
							</table>
						`).join("");

					// Detalle de la inspección
					let detalleHtml = "";
					categorias.forEach((cat) => {
						let detCount = 0;
						const detRateCounts = {};
						(cat.details || []).forEach((d) => {
							const r = Number(d.rate);
							const rm = rs.rateMap[r];
							if (!rm || rm.es_na) return;
							detCount++;
							detRateCounts[r] = (detRateCounts[r] || 0) + 1;
						});
						let detDomRate = rs.rateNA;
						if (detCount > 0) {
							let maxCount = -1;
							Object.keys(detRateCounts).forEach((r) => {
								if (detRateCounts[r] > maxCount) { maxCount = detRateCounts[r]; detDomRate = Number(r); }
							});
						}

						const filas = (cat.details || []).map((d) => `
							<tr>
								<td colspan="2" class="det-item-name">${escapeHtml(d.title || "")}</td>
								<td class="det-item-badge"><span class="badge ${rs.badge(Number(d.rate))}">${escapeHtml(rs.label(Number(d.rate)))}</span></td>
							</tr>
						`).join("");

						detalleHtml += `
							<table class="det-block" cellpadding="0" cellspacing="0">
								<tr class="det-hdr-tr">
									<td class="det-hdr-name" style="width:38%;">${escapeHtml(cat.category_name || "")}</td>
									<td style="padding:5px 8px;border-bottom:1px solid #ccc;width:42%;"></td>
									<td class="det-hdr-badge" style="width:20%;"><span class="badge ${rs.badge(detDomRate)}">${escapeHtml(rs.label(detDomRate))}</span></td>
								</tr>
								${cat.category_comment ? `
								<tr style="background:#fff;">
									<td colspan="3" style="padding:4px 8px;font-size:7.5pt;color:#555;font-style:italic;border-bottom:1px solid #ebebeb;">
										<span style="color:#e07b2a;font-weight:700;font-style:normal;">Obs:</span> ${escapeHtml(cat.category_comment)}
									</td>
								</tr>` : ""}
								${filas}
							</table>
						`;
					});

					return `
					<div class="report-page"${isLast ? "" : " style=\"page-break-after:always;\""}>
						<table class="hdr" cellpadding="0" cellspacing="0">
							<tr>
								<td class="hdr-logo-td">
									<img src="https://erp.seway.com.co/layout/images/logo-seway-plus.png" alt="Logo"/>
								</td>
								<td class="hdr-title-td">
									<h1>${escapeHtml(preoperativo.checklist_general_tittle || "INSPECCIÓN VEHICULAR")}</h1>
									<p>Plan Estratégico de Seguridad Vial · PESV</p>
								</td>
								<td class="hdr-meta-td">
									<table class="hdr-meta" cellpadding="0" cellspacing="0">
										<tr><td class="lbl">Código</td><td class="val">${escapeHtml(codigo)}</td></tr>
										<tr><td class="lbl">Fecha</td><td class="val">${escapeHtml(fecha)}</td></tr>
									</table>
								</td>
							</tr>
						</table>

						<table class="rs-tbl" cellpadding="0" cellspacing="0">
							<tr>
								<td class="rs-left-td">
									<div class="banner ${bCls}">
										<div class="banner-eye ${bEye}">Resultado de la inspección</div>
										<div class="banner-status ${bStC}">${bStat}</div>
										<div class="banner-desc">${bDesc}</div>
									</div>
								</td>
								<td class="rs-right-td">
									<table class="sc" cellpadding="0" cellspacing="0">
										<tr>
											<td class="sc-pct ${pctBad ? "sc-pct-bad" : ""}">${pct}%</td>
											<td class="sc-pct-label">óptimo</td>
											<td>
												<table class="sc-inner" cellpadding="0" cellspacing="0" width="100%">
													<tr><td class="sc-label">Ítems</td><td class="sc-val">${totalItems}</td></tr>
													<tr><td class="sc-label">Por revisar</td><td class="sc-val ${porRevisar > 0 ? "sc-val-alert" : ""}">${porRevisar}</td></tr>
													<tr><td colspan="2" style="padding-top:6px;">
														<table width="100%" cellpadding="0" cellspacing="0" style="height:7px;border-radius:4px;overflow:hidden;background:#ddd;">
															<tr>
																${barW > 0 ? `<td style="width:${barW}%;height:7px;background:${pctBad ? "#c0392b" : "#2e9e4f"};"></td>` : ""}
																${barEmp > 0 ? `<td style="width:${barEmp}%;height:7px;background:#ddd;"></td>` : ""}
															</tr>
														</table>
													</td></tr>
												</table>
											</td>
										</tr>
									</table>
								</td>
							</tr>
						</table>

						<table class="dcard" cellpadding="0" cellspacing="0">
							<tr><td colspan="3" class="dcard-hdr">Datos del conductor</td></tr>
							<tr>
								<td style="padding:5px 8px;border-right:1px solid #ebebeb;"><span class="dl">Tipo documento</span><span class="dv">C.C.</span></td>
								<td style="padding:5px 8px;border-right:1px solid #ebebeb;"><span class="dl">Documento</span><span class="dv">${escapeHtml(item.documento_conductor || "")}</span></td>
								<td style="padding:5px 8px;"><span class="dl">Nombre completo</span><span class="dv">${escapeHtml(item.nombre_conductor || item.conductor_nombre || "")}</span></td>
							</tr>
						</table>

						<table class="dcard" cellpadding="0" cellspacing="0">
							<tr><td colspan="3" class="dcard-hdr">Datos del vehículo</td></tr>
							<tr>
								<td style="padding:5px 8px;border-bottom:1px solid #ebebeb;border-right:1px solid #ebebeb;"><span class="dl">Placa</span><span class="dv">${campoVehiculo("placa", datosVehiculo.placa)}</span></td>
								<td style="padding:5px 8px;border-bottom:1px solid #ebebeb;border-right:1px solid #ebebeb;"><span class="dl">Núm. licencia tránsito</span><span class="dv">${campoVehiculo("matricula", datosVehiculo.numero_matricula)}</span></td>
								<td style="padding:5px 8px;border-bottom:1px solid #ebebeb;"><span class="dl">Marca</span><span class="dv">${campoVehiculo("marca", datosVehiculo.marca)}</span></td>
							</tr>
							<tr>
								<td style="padding:5px 8px;border-bottom:1px solid #ebebeb;border-right:1px solid #ebebeb;"><span class="dl">Modelo</span><span class="dv">${campoVehiculo("modelo", datosVehiculo.modelo)}</span></td>
								<td style="padding:5px 8px;border-bottom:1px solid #ebebeb;border-right:1px solid #ebebeb;"><span class="dl">Cilindraje</span><span class="dv">${campoVehiculo("cilindraje", datosVehiculo.cilindraje)}</span></td>
								<td style="padding:5px 8px;border-bottom:1px solid #ebebeb;"><span class="dl">Clase vehículo</span><span class="dv">${campoVehiculo("tipo_vehiculo", datosVehiculo.clase_vehicular_descripcion)}</span></td>
							</tr>
							<tr>
								<td style="padding:5px 8px;border-right:1px solid #ebebeb;"><span class="dl">Combustible</span><span class="dv">${campoVehiculo("combustible", datosVehiculo.combustible)}</span></td>
								<td style="padding:5px 8px;border-right:1px solid #ebebeb;"><span class="dl">Número motor</span><span class="dv">${campoVehiculo("motor", datosVehiculo.motor)}</span></td>
								<td style="padding:5px 8px;"><span class="dl">Número chasis</span><span class="dv">${campoVehiculo("chasis", datosVehiculo.chasis)}</span></td>
							</tr>
						</table>

						<div class="sec-lbl">Resumen por categoría</div>
						${resumenHtml}

						<div class="sec-lbl">Hallazgos por revisar</div>
						${hallazgosHtml}

						<div class="sec-lbl">Detalle de la inspección</div>
						${detalleHtml}

						${preoperativo.checklist_general_observation ? `
						<div class="obs-box">
							<div class="obs-title">Observaciones generales</div>
							<div class="obs-text">${escapeHtml(preoperativo.checklist_general_observation)}</div>
						</div>` : ""}

						${preoperativo.checklist_general_clause ? `
						<p class="clause"><strong>Cláusula.</strong> ${escapeHtml(preoperativo.checklist_general_clause)}</p>` : ""}

						<table class="sigs-tbl" cellpadding="0" cellspacing="0">
							<tr>
								<td>
									${item.firma_conductor ? `<img src="${escapeHtml(normalizeUrl(item.firma_conductor))}" alt="Firma conductor" class="sig-img"/>` : `<div style="height:55px;"></div>`}
									<div class="sig-line">${escapeHtml(item.nombre_conductor || item.conductor_nombre || "")}<div class="sig-sub">Firma del conductor · C.C. ${escapeHtml(item.documento_conductor || "")}</div></div>
								</td>
								<td>
									${preoperativo.approval_signature ? `<img src="${escapeHtml(normalizeUrl(preoperativo.approval_signature))}" alt="Firma inspector" class="sig-img"/>` : `<div style="height:55px;"></div>`}
									<div class="sig-line">Inspector responsable<div class="sig-sub">Firma y sello</div></div>
								</td>
							</tr>
						</table>

						<table class="footer-tbl" cellpadding="0" cellspacing="0">
							<tr>
								<td>Inspección vehicular · PESV · Certificación ${escapeHtml(codigo)}</td>
								<td class="footer-right">Generado el ${fmtFecha(Date.now())}</td>
							</tr>
						</table>
					</div>
					`;
				};

				const allSectionsHtml = rawData.map((item, idx) => buildPagina(item, idx === rawData.length - 1)).join("");

				const finalHtml = `<!doctype html>
<html lang="es">
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width,initial-scale=1" />
<title>Inspección Vehicular</title>
<style>
	@page { margin: 0.9cm 1.1cm 1cm 1.1cm; }
	* { box-sizing: border-box; margin: 0; padding: 0; }
	body { font-family: Arial, Helvetica, sans-serif; font-size: 8.5pt; color: #1a1a2e; background: #fff; line-height: 1.45; margin: 0.9cm 1cm 1cm 1cm; }
	table, tr, td, th, div, span, p, h1, h2, h3, h4 { font-family: Arial, Helvetica, sans-serif; }
	table { border-collapse: collapse; }

	.hdr { width: 100%; border-bottom: 2.5px solid #e07b2a; margin-bottom: 10px; padding-bottom: 3px; }
	.hdr td { vertical-align: middle; padding: 0; padding-bottom: 10px; }
	.hdr-logo-td { width: 62px; }
	.hdr-logo-td img { width: 70px; height: 56px; border-radius: 8px; display: block; object-fit: contain; }
	.hdr-title-td { padding-left: 20px; }
	.hdr-title-td h1 { padding-left: 20px; font-size: 15pt; }
	.hdr-title-td p { font-size: 8pt; color: #666; margin-top: 2px; padding-left: 20px; }
	.hdr-meta-td { width: 160px; text-align: right; vertical-align: middle; }
	.hdr-meta { width: 160px; border-collapse: collapse; font-size: 8pt; }
	.hdr-meta td { padding: 3px 7px; border: 1px solid #ccc; }
	.hdr-meta .lbl { background: #f0f0f0; color: #666; font-weight: 700; text-transform: uppercase; font-size: 7pt; letter-spacing: 0.05em; white-space: nowrap; }
	.hdr-meta .val { font-weight: 700; color: #1a1a2e; }

	.rs-tbl { width: 100%; margin-bottom: 10px; }
	.rs-tbl td { vertical-align: middle; }
	.rs-left-td { width: 55%; padding-right: 8px; }
	.rs-right-td { width: 45%; }

	.banner { border-radius: 7px; padding: 10px 13px; border-width: 1.5px; border-style: solid; }
	.banner-apto { background: #edf8f1; border-color: #9dd5b2; }
	.banner-no-apto { background: #fdeaea; border-color: #e9a3a3; }
	.banner-pend { background: #fef9e7; border-color: #f0d080; }
	.banner-eye { font-size: 7pt; font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase; margin-bottom: 3px; }
	.c-green-dk { color: #1d6b35; }
	.c-red { color: #9b1c1c; }
	.c-yellow { color: #92611a; }
	.banner-status { font-size: 18pt; font-weight: bold; margin-bottom: 4px; }
	.c-green { color: #2e9e4f; }
	.c-red2 { color: #c0392b; }
	.c-yellow2 { color: #d4a017; }
	.banner-desc { font-size: 7.5pt; color: #555; line-height: 1.5; }

	.sc { width: 100%; border: 1.5px solid #ccc; border-radius: 15px; padding: 20px 0; }
	.sc td { padding: 0; }
	.sc-inner { width: 100%; padding: 21px 13px; }
	.sc-pct { font-size: 30pt; font-weight: bold; color: #2e9e4f; text-align: center; }
	.sc-pct-bad { color: #c0392b; }
	.sc-pct-label { font-size: 7pt; color: #888; text-align: right; }
	.sc-label { font-size: 8pt; color: #555; }
	.sc-val { font-size: 8.5pt; font-weight: 700; color: #1a1a2e; text-align: right; }
	.sc-val-alert { color: #c0392b; }

	.sec-lbl { border-left: 3px solid #e07b2a; background: #f5f5f5; padding: 4px 9px; font-size: 7.5pt; font-weight: 700; letter-spacing: 0.07em; text-transform: uppercase; color: #e07b2a; margin: 10px 0 5px; }

	.dcard { width: 100%; margin-bottom: 8px; border: 1px solid #ccc; border-collapse: collapse; }
	.dcard-hdr { background: #f0f0f0; padding: 4px 8px; font-size: 7.5pt; font-weight: 700; text-transform: uppercase; letter-spacing: 0.06em; color: #e07b2a; border-bottom: 1px solid #ccc; }
	.dl { color: #777; font-size: 7pt; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; display: block; margin-bottom: 1px; }
	.dv { font-weight: 700; color: #1a1a2e; font-size: 8.5pt; }

	.cat-tbl { width: 100%; margin-bottom: 4px; }
	.cat-tbl td { vertical-align: middle; }
	.cat-name-td { width: 28%; color: #1a1a2e; padding-right: 8px; }
	.cat-bar-td { width: 58%; }
	.cat-badge-td { width: 14%; text-align: right; padding-left: 8px; }

	.badge { display: inline-block; padding: 2px 9px; border-radius: 999px; font-size: 7.5pt; font-weight: 700; white-space: nowrap; }
	.b-ex { background: #e6f5eb; color: #1d6b35; }
	.b-ok { background: #e6f5eb; color: #2e9e4f; }
	.b-reg { background: #fef9e7; color: #92611a; }
	.b-bad { background: #fdeaea; color: #9b1c1c; }
	.b-vbad { background: #fdeaea; color: #7b0000; }
	.b-na { background: #f0f0f0; color: #777; }

	.hall-empty { border: 1.5px solid #9dd5b2; background: #edf8f1; border-radius: 5px; padding: 9px; text-align: center; font-size: 8.5pt; font-weight: 700; color: #1d6b35; margin-bottom: 6px; }
	.hall-tbl { width: 100%; margin-bottom: 4px; border: 1px solid #ddd; border-collapse: collapse; }
	.hall-tbl td { padding: 5px 8px; vertical-align: middle; }
	.hall-cat { background: #fdeaea; color: #9b1c1c; font-size: 7.5pt; font-weight: 700; width: 28%; border-right: 1px solid #ddd; }
	.hall-name { font-size: 8.5pt; }
	.hall-rate { text-align: right; width: 80px; }

	.det-block { width: 100%; margin-bottom: 8px; border: 1px solid #ccc; border-collapse: collapse; page-break-inside: avoid; }
	.det-hdr-tr { background: #f0f0f0; }
	.det-hdr-name { padding: 5px 8px; font-size: 8.5pt; font-weight: 700; color: #1a1a2e; border-bottom: 1px solid #ccc; }
	.det-hdr-badge { padding: 5px 8px; text-align: right; border-bottom: 1px solid #ccc; }
	.det-item-name { padding: 4px 8px; font-size: 8pt; color: #1a1a2e; width: 75%; border-bottom: 1px solid #ebebeb; border-right: 1px solid #ebebeb; }
	.det-item-badge { padding: 4px 8px; text-align: right; border-bottom: 1px solid #ebebeb; }
	.det-block tr:last-child .det-item-name, .det-block tr:last-child .det-item-badge { border-bottom: none; }

	.obs-box { border: 1px solid #ccc; background: #f8f8f8; padding: 8px 11px; margin-bottom: 8px; }
	.obs-title { font-size: 8pt; font-weight: 700; color: #1a1a2e; margin-bottom: 4px; }
	.obs-text { font-size: 8pt; color: #555; line-height: 1.6; }
	.clause { font-size: 8pt; color: #555; line-height: 1.7; margin-bottom: 12px; }
	.clause strong { color: #1a1a2e; }

	.sigs-tbl { width: 100%; margin-top: 20px; }
	.sigs-tbl td { text-align: center; width: 50%; vertical-align: bottom; padding: 0 16px; }
	.sig-img { height: 55px; max-width: 190px; object-fit: contain; display: block; margin: 0 auto 6px; }
	.sig-line { border-top: 1.5px solid #1a1a2e; padding-top: 5px; font-size: 8pt; font-weight: 700; color: #1a1a2e; }
	.sig-sub { font-size: 7.5pt; font-weight: 400; color: #777; margin-top: 1px; }

	.footer-tbl { width: 100%; margin-top: 14px; border-top: 1px solid #ccc; padding-top: 5px; }
	.footer-tbl td { font-size: 7.5pt; color: #888; padding-top: 5px; }
	.footer-right { text-align: right; }
</style>
</head>
<body>
${allSectionsHtml}
</body>
</html>`;

				const newWindow = window.open("", "_blank");
				newWindow.document.open();
				newWindow.document.write(finalHtml);
				newWindow.document.close();

				_that.loader = false;
            }).catch((error) => {
				_that.loader = false;
				if (error.response){
					if (error.response.status==414) {
						_that.$toast.add({severity:'warn', summary: 'Falta información', detail:'No se encuentra preoperativo de este viaje', life: 4000});
					}
					if (error.response.status==423) {
						_that.$toast.add({severity:'warn', summary: 'Falta información', detail:'El rango de fechas no puede ser superior a 30 días', life: 4000});
					}
					if (error.response.status>=500) {
						_that.$toast.add({severity:'warn', summary: 'Ocurrio un Error', detail:'El proceso se ha cancelado por un error en el servidor', life: 4000});
					}
				}
			});
        },
		async downloadPreoperacional(formato){
			if(this.num_movimiento=='' || this.num_movimiento==0){
				this.submitted = true;
				this.$toast.add({severity:'error', summary: 'Número de Movimiento Vacio!', detail:'Favor ingresar un número de mov', life: 4000});
				return
			}
			this.loader = true;
            var _that = this;
            axios({
            url: '/generarpdfpreoperacional',
            method: 'POST',
            data: {id_deliverie: this.viaje.id_deliverie,datos_vehiculo: this.datos_vehiculo,id_customer: this.IdCustomer,num_movimiento: this.num_movimiento,formato: formato},
            responseType: 'blob',
            }).then((response) => {
				// var nombrearchivo = _that.datos_vehiculo.placa+'.pdf';
				var nombrearchivo = this.datos_vehiculo.placa+'.'+formato;


                _that.forceFileDownloadQr(response,nombrearchivo);
				_that.loader = false;
            }).catch((error) => {
				// console.error('Error generating PDF:', error);
				console.error(error);
				_that.loader = false;
				// if (error.status==414) {
					_that.$toast.add({severity:'warn', summary: 'Falta información', detail:'No se encuentra preoperativo de este viaje', life: 4000});
				// }
				// Aquí puedes mostrar un mensaje de error al usuario si es necesario
			});
        },
		forceFileDownloadQr(response,nombrearchivo){
            // console.log(response);
            
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', nombrearchivo); //or any other extension
            document.body.appendChild(link);
            link.click();
			this.loader = false;
        },
		downloadMovimientos(){

			if(this.fecha=='' || this.fecha_fin==''){
				// console.log(this.text_filter);
				this.$toast.add({severity:'error', summary: 'Falta información', detail:'Favor seleccionar una fecha inicio y una fecha fin a filtrar (rando de 30 dias!)', life: 4000});
				return;
			}
			const cookieName = 'Email';
			const IdRol = 'IdRol';
			let cookie = {};
			document.cookie.split(';').forEach(function(el) {
			let [key,value] = el.split('=');
			cookie[key.trim()] = value;
			})
			var email = cookie[cookieName];
			var id_rol = cookie[IdRol];
			this.loader = true;
            var _that = this;
            axios({
            url: '/export_movimientos_sincronizados',
            method: 'POST',
            data: {email: email,id_rol: id_rol,fecha: this.fecha,fecha_fin: this.fecha_fin},
            responseType: 'blob',
            }).then((response) => {
				var nombrearchivo = 'reporte_movimientos.'+this.formato_archivo;
                _that.forceFileDownloadQr(response,nombrearchivo);
				_that.loader = false;
            }).catch((error) => {
				_that.loader = false;
				console.log(error);
				console.log(error.response.status);
				if(error.response.status==422){

					_that.$toast.add({severity:'error', summary: 'Error', detail:'El rango de fechas no puede ser superior a 30 días.', life: 6000});
				}
				if(error.response.status==404){

					_that.$toast.add({severity:'error', summary: 'Error', detail:'Ocurrio un error al momento de descargar el documento.', life: 6000});
				}
				
				// Aquí puedes mostrar un mensaje de error al usuario si es necesario
			});
        },
		downloadTiemposLogisticos(){

			if(this.fecha=='' || this.fecha_fin==''){
				// console.log(this.text_filter);
				this.$toast.add({severity:'error', summary: 'Falta información', detail:'Favor seleccionar una fecha inicio y una fecha fin a filtrar (rando de 30 dias!)', life: 4000});
				return;
			}
			const cookieName = 'Email';
			const IdRol = 'IdRol';
			let cookie = {};
			document.cookie.split(';').forEach(function(el) {
			let [key,value] = el.split('=');
			cookie[key.trim()] = value;
			})
			var email = cookie[cookieName];
			var id_rol = cookie[IdRol];
			this.loader = true;
            var _that = this;
            axios({
            url: '/export_events',
            method: 'POST',
            data: {email: email,id_rol: id_rol,id_customer: this.reporte_customer_selected,fecha: this.fecha,fecha_fin: this.fecha_fin},
            responseType: 'blob',
            }).then((response) => {
				var nombrearchivo = 'reporte_tiempos_logisticos.'+this.formato_archivo;
                _that.forceFileDownloadQr(response,nombrearchivo);
				_that.loader = false;
            }).catch((error) => {
				_that.loader = false;
				console.log(error);
				// console.log(error.response);
				// console.log(error.response.status);
				if (error.response) {
					if(error.response.status==414){

						_that.$toast.add({severity:'warn', summary: 'Error', detail:'No se encuentra preoperativos en este rango', life: 6000});
					}
					if(error.response.status==423){

						_that.$toast.add({severity:'error', summary: 'Error', detail:'El rango de fechas no puede ser superior a 30 días.', life: 6000});
					}
					if(error.response.status==404){

						_that.$toast.add({severity:'error', summary: 'Error', detail:'Ocurrio un error al momento de descargar el documento.', life: 6000});
					}
				}else{
					_that.$toast.add({severity:'error', summary: 'Error', detail:'Ocurrio un error al momento de descargar el documento.', life: 6000});
				}
			});
        },
		onspinner(){
			this.loader = true;
		},
		offspinner(){
			this.loader = false;
		},
		showAlert(message){
			this.$toast.add({severity:'error', summary: message, detail:'', life: 6000});
		},
		onDocumentClick() {
			if (!this.searchClick && this.searchActive) {
                this.onSearchHide();
            }

			if(!this.topbarItemClick) {
				this.activeTopbarItem = null;
				this.topbarMenuActive = false;
			}

			if(!this.menuClick) {
				if(this.isHorizontal() || this.isSlim()) {
					this.menuActive = false;
					this.isSlimOrHorItemClick = false;
					EventBus.emit('reset-active-index');
				}

				if (this.isOverlay()) {
                    this.menuActive = false;
                }

				this.hideOverlayMenu();
				this.unblockBodyScroll();
			}

			if(!this.rightPanelClick) {
				this.rightPanelActive = false;
			}

			if(!this.inlineMenuClick) {
				this.inlineMenuTopActive = false;
				this.inlineMenuBottomActive = false;
			}

			this.topbarItemClick = false;
			this.menuClick = false;
			this.rightPanelClick = false;
			this.searchClick = false;
			this.inlineMenuClick = false;
        },
		onSearchToggle() {
            this.searchActive = !this.searchActive;
            this.searchClick = true;
        },
		onSearchClick() {
            this.searchClick = true;
        },
        onSearchHide() {
            this.searchActive = false;
            this.searchClick = false;
        },
		isHorizontal() {
			return this.menuMode === 'horizontal';
		},
		isSlim() {
			return this.menuMode === 'slim';
		},
		isOverlay() {
			return this.menuMode === 'overlay';
		},
		isStatic() {
			return this.menuMode === 'static';
		},
		isDesktop() {
			return window.innerWidth > 991;
		},
		isMobile() {
			return window.innerWidth <= 991;
		},
		hideOverlayMenu() {
			this.rotateMenuButton = false;
			this.overlayMenuActive = false;
			this.mobileMenuActive = false;
		},
		onMenuButtonClick(event){
			this.menuClick = true;
			this.menuActive = !this.menuActive;
			this.topbarMenuActive = false;
			this.topbarRightClick = true;
			this.rotateMenuButton = !this.rotateMenuButton;
			this.topbarMenuActive = false;

			if(!this.isDesktop()) {
				this.mobileMenuActive = !this.mobileMenuActive;
				if (this.mobileMenuActive) {
					this.blockBodyScroll();
				} else {
					this.unblockBodyScroll();
				}
			}

			event.preventDefault();
		},
		onTopbarMenuButtonClick(event) {
			this.topbarItemClick = true;
			this.topbarMenuActive = !this.topbarMenuActive;
			this.hideOverlayMenu();
			event.preventDefault();
		},
		onTopbarItemClick(event){
			this.topbarItemClick = true;

			if(this.activeTopbarItem === event.item)
				this.activeTopbarItem = null;
			else
				this.activeTopbarItem = event.item;

			event.originalEvent.preventDefault();
		},
		onTopbarMobileButtonClick(event) {
			this.mobileTopbarActive = !this.mobileTopbarActive;
			event.preventDefault();
		},
		onRightPanelButtonClick(event){
			this.rightPanelClick = true;
			this.rightPanelActive = !this.rightPanelActive;

			event.preventDefault();
		},
		onRightPanelClick(){
			this.rightPanelClick = true;
		},
		onHideClick(expanded){
			this.rightPanelActive = expanded;
		},
		onMenuClick() {
			this.menuClick = true;
		},
		onRootMenuItemClick(event) {
            if(event.isSameIndex) {
                this.isSlimOrHorItemClick = false;
            }
            else {
                this.isSlimOrHorItemClick = true;
            }
			this.menuActive = !this.menuActive;
		},
		onMenuItemClick(event) {
			if(!event.item.items) {
                this.isSlimOrHorItemClick = false;
				this.hideOverlayMenu();
				EventBus.emit('reset-active-index');
			}

			if(!event.item.items && (this.isHorizontal() || this.isSlim())) {
				this.menuActive = false;
			}
		},
		onMenuModeChange(menuMode) {
			this.menuMode = menuMode;
			this.overlayMenuActive = false;
			
			if(menuMode === 'static') {
				this.menuActive = true;
			}

			if(menuMode === 'horizontal') {
				this.inlineMenuPosition = 'bottom';
			}
		},
		onLayoutModeChange(menuColor) {
			this.$emit('layout-mode-change', menuColor);

			const layoutLink = document.getElementById('layout-css');
			const layoutHref = 'layout/css/layout-' + menuColor + '.css';
			this.replaceLink(layoutLink, layoutHref);

			const themeLink = document.getElementById('theme-css');
			const urlTokens = themeLink.getAttribute('href').split('/');
			urlTokens[urlTokens.length - 1] = 'theme-' + menuColor + '.css';
			const newURL = urlTokens.join('/');

			this.replaceLink(themeLink, newURL, () => {
				this.$appState.isNewThemeLoaded = true;
			});
		},
		onInlineMenuPositionChange(position) {
			this.inlineMenuPosition = position;
		},
		onChangeInlineMenu(e, key) {
			if(key === 'top') {
				if(this.inlineMenuBottomActive) {
					this.inlineMenuBottomActive = false;
				}
				this.inlineMenuTopActive = !this.inlineMenuTopActive;
			}
			if(key === 'bottom') {
				if(this.inlineMenuTopActive) {
					this.inlineMenuTopActive = false;
				}
				this.inlineMenuBottomActive = !this.inlineMenuBottomActive;
			}

			this.inlineMenuClick = true;
			
		},
		changeTheme(theme) {
			this.theme = theme;
			this.changeStyleSheetUrl('theme-css', theme);
		},
		onTopbarThemeChange(theme) {
			this.$emit('topbar-theme', theme);
		},
		onMenuTheme(menuTheme) {
			this.$emit('menu-theme', menuTheme);
		},
		changeStyleSheetUrl(id, value) {
			const element = document.getElementById(id);
			const urlTokens = element.getAttribute('href').split('/');
			urlTokens[urlTokens.length - 2] = value;
			const newURL = urlTokens.join('/');
			this.replaceLink(element, newURL);
		},
		replaceLink(linkElement, href, callback) {
			const id = linkElement.getAttribute('id');
			const cloneLinkElement = linkElement.cloneNode(true);

			cloneLinkElement.setAttribute('href', href);
			cloneLinkElement.setAttribute('id', id + '-clone');

			linkElement.parentNode.insertBefore(cloneLinkElement, linkElement.nextSibling);

			cloneLinkElement.addEventListener('load', () => {
				linkElement.remove();
				cloneLinkElement.setAttribute('id', id);

				if (callback) {
					callback();
				}
			});
		},
		blockBodyScroll() {
            if (document.body.classList) {
                document.body.classList.add('blocked-scroll');
            } else {
                document.body.className += ' blocked-scroll';
            }
        },
        unblockBodyScroll() {
            if (document.body.classList) {
                document.body.classList.remove('blocked-scroll');
            } else {
                document.body.className = document.body.className.replace(new RegExp('(^|\\b)' +
                    'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
            }
        },
		async cargarMenu() {
            try {
                const menuFiltrado = await this.construirMenuEmpresaTransporte();
                this.menu = menuFiltrado;
            } catch (error) {
                console.error('Error cargando menú:', error);
                // En caso de error, mostrar solo inicio
                this.menu = [this.menuBaseEmpresaTransporte[0]];
            }
        },
        async cargarPermisosIniciales() {
			try {
				const response = await window.api.call('post', 'consulta_ingreso', { 
					ruta: this.$route.path || '/empresa-transporte/inicio' 
				});
				
				if (response.status === 200 && response.data.code === 1) {
					this.modulosDisponibles  = response.data.permisos || [];
					this.permisos_detallados = response.data.permisos_detallados ?? [];
					this.construirMenu();
				}
				// Si code === 0 no tocar el menú ya construido
			} catch (error) {
				console.error('Error cargando permisos iniciales:', error);
				this.menu = [this.menuBaseEmpresaTransporte[0]];
			}
		},
        construirMenu() {
			const esSuperAdmin = this.SupAdm == 1 || this.permisos_detallados === 'all';

			// Si no es superadmin y no tiene módulos, solo mostrar inicio
			if (!esSuperAdmin && this.modulosDisponibles.length === 0) {
				this.menu = [
					{
						label: '',
						icon: 'pi pi-fw pi-home',
						items: [
							{ 
								label: 'Inicio', 
								icon: 'pi pi-fw pi-home', 
								to: this.$store.getters['infoNavigation/Rol'] + '/' 
							}
						]
					}
				];
				return;
			}

			// Función auxiliar para verificar si tiene acceso a un módulo
			const tieneAccesoModulo = (idModulo) => {
				if (esSuperAdmin) return true;
				return this.modulosDisponibles.some(m => m.id === idModulo);
			};

			// Función auxiliar para verificar si tiene acceso a un proceso específico
			const tieneAccesoProceso = (idModulo, idProceso) => {
				if (esSuperAdmin) return true;
				return this.permisos_detallados.some(p => 
					p.id_modulo === idModulo && p.id_proceso === idProceso
				);
			};

			// Construir menú dinámicamente
			const menuFiltrado = [];
			
			// 1. Inicio - siempre visible
			menuFiltrado.push({
				label: '',
				icon: 'pi pi-fw pi-home',
				items: [
					{ 
						label: 'Inicio', 
						icon: 'pi pi-fw pi-home', 
						to: this.$store.getters['infoNavigation/Rol'] + '/' 
					}
				]
			});

			// 2. Movimientos (Módulo 1) - SIEMPRE VERSIÓN 2, SIN VALIDACIÓN SerCon
			if (tieneAccesoModulo(1)) {
				const movimientosItems = [];
				
				// SIEMPRE mostrar solo Movimientos APP 2
				movimientosItems.push({
					key: 'mov_app_2',
					label: 'Viajes',
					icon: 'pi pi-fw pi-truck',
					to: this.$store.getters['infoNavigation/Rol'] + '/viajes-seway'
				});

				menuFiltrado.push({
					label: '',
					icon: 'pi pi-fw pi-sitemap',
					items: [
						{
							label: 'Movimientos',
							icon: 'pi pi-fw pi-sitemap',
							items: movimientosItems
						}
					]
				});
			}




			// 3. Recursos (Módulo 7)
			const recursosItems = [];
			
			if (tieneAccesoProceso(7, 22)) {
				recursosItems.push({
					label: 'Terceros',
					icon: 'pi pi-fw pi-users',
					to: this.$store.getters['infoNavigation/Rol'] + '/hv-conductores'
				});
			}
			
			if (tieneAccesoProceso(7, 21)) {
				recursosItems.push({
					label: 'Vehículos',
					icon: 'pi pi-fw pi-truck',
					to: this.$store.getters['infoNavigation/Rol'] + '/hv-vehiculos'
				});
			}

			if (recursosItems.length > 0) {
				menuFiltrado.push({
					label: '',
					icon: 'pi pi-fw pi-globe',
					items: [
						{
							label: 'Recursos',
							icon: 'pi pi-fw pi-globe',
							items: recursosItems
						}
					]
				});
			}







			// 4. Contable (Módulos 2 y 3)
			const contableItems = [];
			
			// if (tieneAccesoModulo(3)) {
			// 	contableItems.push({
			// 		label: 'Cartera',
			// 		icon: 'pi pi-fw pi-wallet',
			// 		to: this.$store.getters['infoNavigation/Rol'] + '/pendientes'
			// 	});
			// }
			
			if (tieneAccesoModulo(2)) {
				contableItems.push({
					label: 'Legalización Gastos',
					icon: 'pi pi-fw pi-wallet',
					to: this.$store.getters['infoNavigation/Rol'] + '/legalizacion-gastos'
				});
			}

			if (contableItems.length > 0) {
				menuFiltrado.push({
					label: '',
					icon: 'pi pi-fw pi-wallet',
					items: [
						{
							label: 'Contable',
							icon: 'pi pi-fw pi-wallet',
							items: contableItems
						}
					]
				});
			}

			// 7. aprobaciones (Módulo 8)
			if (tieneAccesoModulo(8) || esSuperAdmin) {
				menuFiltrado.push({
					label: '',
					icon: 'pi pi-fw pi-check-circle',
					items: [
						{ 
							label: 'Aprobaciones', 
							icon: 'pi pi-fw pi-check-circle', 
							to: this.$store.getters['infoNavigation/Rol'] + '/aprobaciones' 
						}
					]
				});
			}

			// 5. Reportes (Módulo 4)
			if (tieneAccesoModulo(4)) {
				menuFiltrado.push({
					label: '',
					icon: 'pi pi-fw pi-file-pdf',
					items: [
						{
							label: 'Reportes',
							icon: 'pi pi-fw pi-file-pdf',
							command: () => { this.click_report(); }
						}
					]
				});
			}

			// 6. Configuraciones (Módulo 6) - CON FILTRADO DE SUB-PROCESOS
			if (tieneAccesoModulo(6) || esSuperAdmin) {
				const configItems = [];

				// Super Admin - Administración
				if (esSuperAdmin) {
					configItems.push({
						key: 'administracion',
						label: 'Administración',
						icon: 'pi pi-fw pi-desktop',
						items: [
							{
								label: 'Usuarios',
								icon: 'pi pi-fw pi-users',
								to: this.$store.getters['infoNavigation/Rol'] + '/configuracion/admin-usuarios'
							},
							{
								label: 'Perfiles',
								icon: 'pi pi-fw pi-bookmark-fill',
								to: this.$store.getters['infoNavigation/Rol'] + '/configuracion/perfiles'
							}
						]
					});

					
				}

				if (tieneAccesoProceso(6, 25) || esSuperAdmin) {
					// Super Admin - Conectores
					configItems.push({
						key: 'conectores',
						label: 'Conectores',
						icon: 'pi pi-fw pi-share-alt',
						items: [
							{
								label: 'Webhooks',
								icon: 'pi pi-fw pi-bolt',
								to: this.$store.getters['infoNavigation/Rol'] + '/configuracion/webhooks'
							}
						]
					});
				}
				

				// Mobile - Filtrado por procesos
				const mobileItems = [];
				
				// Proceso 12 - Ver conductores
				if (tieneAccesoProceso(6, 12)) {
					mobileItems.push({
						label: 'Conductores', 
						icon: 'pi pi-fw pi-users', 
						to: this.$store.getters['infoNavigation/Rol'] + '/configuracion/usuarios'
					});
				}
				
				// Proceso 13 - Ver eventos logísticos
				if (tieneAccesoProceso(6, 13)) {
					mobileItems.push({
						label: 'Eventos Logisticos', 
						icon: 'pi pi-fw pi-history', 
						to: this.$store.getters['infoNavigation/Rol'] + '/configuracion/eventos'
					});
				}
				
				// Proceso 14 - Ver Pre Operacional
				if (tieneAccesoProceso(6, 14)) {
					mobileItems.push({
						label: 'Pre Operacional', 
						icon: 'pi pi-fw pi-calendar', 
						to: this.$store.getters['infoNavigation/Rol'] + '/configuracion/pesv'
					});
				}
				
				// Proceso 15 - Ver tipo gastos
				if (tieneAccesoProceso(6, 15)) {
					mobileItems.push({
						label: 'Tipo Gastos',
						icon: 'pi pi-fw pi-wallet',
						to: this.$store.getters['infoNavigation/Rol'] + '/configuracion/tipo-gastos'
					});
				}

				// Proceso 26 - Ver motivos anulación
				if (tieneAccesoProceso(6, 26)) {
					mobileItems.push({
						label: 'Motivos Anulación',
						icon: 'pi pi-fw pi-ban',
						to: this.$store.getters['infoNavigation/Rol'] + '/configuracion/motivos-anulacion'
					});
				}

				const documentsItems = [];

				// if (tieneAccesoProceso(6, 12)) {
					documentsItems.push({
						label: 'Administrar Firmas', 
						icon: 'pi pi-fw pi-pencil', 
						to: this.$store.getters['infoNavigation/Rol'] + '/configuracion/admin-firmas'
					});
				// }

				if (documentsItems.length > 0) {
					if (tieneAccesoProceso(6, 23) || esSuperAdmin) {
						mobileItems.push({
							label: 'Documentos', 
							icon: 'pi pi-fw pi-folder-open',
							items: documentsItems
						});
					}
				}

				// Si tiene al menos un permiso en Mobile, agregar sección
				if (mobileItems.length > 0) {
					configItems.push({
						label: 'Mobile', 
						icon: 'pi pi-fw pi-mobile',
						items: mobileItems
					});
				}

				// RNDC - Filtrado por procesos
				// const rndcItems = [];
				
				// // Proceso 17 - Ver terceros
				// if (tieneAccesoProceso(6, 17)) {
				// 	rndcItems.push({
				// 		label: 'Terceros', 
				// 		icon: 'pi pi-fw pi-users', 
				// 		to: this.$store.getters['infoNavigation/Rol'] + '/configuracion/terceros'
				// 	});
				// }
				
				// // Proceso 18 - Ver vehículos
				// if (tieneAccesoProceso(6, 18)) {
				// 	rndcItems.push({
				// 		label: 'Vehiculos', 
				// 		icon: 'pi pi-fw pi-truck', 
				// 		to: this.$store.getters['infoNavigation/Rol'] + '/configuracion/vehiculos'
				// 	});
				// }

				// // Si tiene al menos un permiso en RNDC, agregar sección
				// if (rndcItems.length > 0) {
				// 	configItems.push({
				// 		label: 'RNDC', 
				// 		icon: 'pi pi-fw pi-sitemap',
				// 		items: rndcItems
				// 	});
				// }

				// Solo agregar Configuraciones si tiene al menos una sub-sección
				if (configItems.length > 0) {
					menuFiltrado.push({
						items: [
							{
								label: 'Configuraciones', 
								icon: 'pi pi-fw pi-cog',
								items: configItems
							}
						]
					});
				}
			}

			// Actualizar el menú
			this.menu = menuFiltrado;
			
			// console.log('Menú construido:', this.menu);
			// console.log('Permisos detallados en construirMenu:', this.permisos_detallados);
		}
    },
    computed: {
		menuSize() {
				return this.menu_super_admin2;
			// }
		},
		menuEmpresaTransporte() {
            // Retornar el menu cargado en data
            return this.menuData.length > 0 
                ? this.menuData 
                : [this.menuBaseEmpresaTransporte[0]]; // Solo inicio por defecto
        },
		layoutContainerClass() {
            return [
				'layout-wrapper', 
				'layout-menu-' + this.menuTheme + ' layout-topbar-' + this.topbarTheme, 
				{
					'layout-menu-static': this.menuMode === 'static',
					'layout-menu-overlay': this.menuMode === 'overlay',
					'layout-menu-overlay-active': this.overlayMenuActive,
					'layout-menu-slim': this.menuMode === 'slim',
					'layout-menu-horizontal': this.menuMode === 'horizontal',
					'layout-menu-active': this.menuActive,
					'layout-menu-mobile-active': this.mobileMenuActive,
					'layout-topbar-mobile-active': this.mobileTopbarActive,
					'layout-rightmenu-active': this.rightPanelActive,
					'layout-rtl': this.$appState.RTL,
					'p-input-outlined': this.$primevue.config.inputStyle === 'outlined',
					'p-ripple-disabled': this.$primevue.config.ripple === false
				}
			];
        }
    },
    components: {
        'AppTopBar': AppTopBar,
        'AppInlineMenu': AppInlineMenu,
        'AppMenu': AppMenu,
        'AppConfig': AppConfig,
        'AppFooter': AppFooter,
        // 'AppBreadcrumb': AppBreadcrumb
    }
}
</script>

<style lang="scss">
// @import './App.scss';
.button-orange{
    background: #EB7D10;
    color: white;
}
.button-orange:hover{
    background: #d54000;
    color: white;
}
.text-orange{
    background: white;
    color: #EB7D10;
	border: 1px solid #EB7D10;
}
.button-sewayblue{
    background: #0A354E;
    color: white;
}
.button-sewayblue:hover{
    background: #0c4f77;
    color: white;
}
.text-sewayblue{
    background: white;
    color: #0A354E;
	border: 1px solid #0A354E;
}
// ========== ESTILOS PARA EL MENÚ LATERAL ==========

// Contenedor principal del menú
// ========== ESTILOS PARA EL MENÚ LATERAL ==========

.layout-sidebar,
.layout-menu-container,
.menu-wrapper {
    background: #ffffff !important;
	
}
.layout-menu-indigo .menu-wrapper{
	box-shadow: 1px 0 1px -1px hsla(0, 0%, 68.2%, .2), 1px 0 1px 0 hsla(0, 0%, 68.2%, .2), 1px 0 1px 0 hsla(0, 0%, 68.2%, .2) !important;
}

.layout-menu {
    background: #ffffff !important;
    
    .p-menuitem {
        background: #ffffff !important;
    }
    
    .p-menuitem-link {
        background: #ffffff !important;
        color: #0A354E !important;
        
        &:hover {
            background: #e8f2f7 !important;
            color: #0A354E !important;
        }
    }
    
    .p-menuitem-text {
        color: #0A354E !important;
    }
    
    .p-menuitem-icon {
        color: #0A354E !important;
    }
}

.layout-menuitem {
    background: #ffffff !important;
    
    a {
        background: #ffffff !important;
        color: #0A354E !important;
        
        &:hover {
            background: #e8f2f7 !important;
            color: #0A354E !important;
        }
    }
}

.layout-menu .layout-menuitem-root-text,
.layout-menu .layout-menuitem-text,
.layout-menu a {
    color: #0A354E !important;
}

.layout-menu .layout-menuitem-icon,
.layout-menu .p-menuitem-icon,
.layout-menu i {
    color: #0A354E !important;
}

.layout-menu .layout-menuitem:not(.active-menuitem):hover,
.layout-menu .layout-menuitem-content:hover {
    background: #e8f2f7 !important;
}

// Item activo - forzar texto e íconos en blanco
.layout-menu .layout-menuitem.active-menuitem > .layout-menuitem-content,
.layout-menu .layout-menuitem.active-menuitem > .layout-menuitem-content a,
.layout-menu .layout-menuitem.active-menuitem > .layout-menuitem-content .layout-menuitem-text,
.layout-menu .layout-menuitem.active-menuitem > .layout-menuitem-content i,
.layout-menu .layout-menuitem.active-menuitem > .layout-menuitem-content .p-menuitem-icon,
.layout-menu .router-link-active,
.layout-menu .router-link-exact-active {
    // background: #0A354E !important;
	background: #eb831c !important;
	background: linear-gradient(90deg, rgba(235, 131, 28, 1) 0%, rgba(242, 154, 65, 1) 50%, rgba(250, 189, 127, 1) 100%) !important;
    color: #ffffff !important;
    border-radius: 6px;

    span, i, .layout-menuitem-text, .p-menuitem-icon {
        color: #ffffff !important;
    }
}

// Nombre y cargo del usuario en el inline menu
.layout-inline-menu {
    background: #ffffff !important;

    .layout-inline-menu-action {
        background: #ffffff !important;

        span {
            color: #0A354E !important;  // ← texto oscuro visible sobre fondo blanco
        }

        small {
            color: #64748b !important;  // ← cargo en gris
        }

        .font-bold {
            color: #0A354E !important;
        }
    }
}

// Submenu
.layout-menu .layout-submenu-wrapper,
.layout-menu .layout-root-menuitem .layout-menuitem-root-text + ul {
    background: #f4f8fb !important;
    
    .p-menuitem-link {
        background: #f4f8fb !important;
        color: #0A354E !important;
        
        &:hover {
            background: #e8f2f7 !important;
        }
    }
}

.layout-menu .layout-submenu-wrapper .layout-menuitem {
    background: #f4f8fb !important;
}

.layout-menu .layout-submenu-toggler,
.layout-menu .p-submenu-icon {
    color: #0A354E !important;
}

.layout-menu .layout-menuitem-separator {
    border-top: 1px solid #e2e8f0 !important;
}

.layout-menu .p-badge {
    background: #EB7D10 !important;
}

.layout-menu .layout-menuitem-root-text {
    color: #64748b !important;
    font-weight: 600;
    background: #ffffff !important;
}

.layout-menu li {
    background: #ffffff !important;
}
// .layout-menu li:hover {
//     // background: #cce7ff !important;
// 	// background: linear-gradient(90deg, rgba(204, 231, 255, 1) 0%, rgba(212, 238, 255, 1) 50%, rgba(255, 255, 255, 1) 100%) !important;
// 	// background: RGB(117, 180, 225) !important;
// 	// background: linear-gradient(90deg, rgba(117, 180, 225, 1) 0%, rgba(212, 238, 255, 1) 50%) !important;
// 	color: rgba(117, 180, 225, 1) !important;
// }

.layout-menu ul {
    background: #ffffff !important;
}
// ══ MODAL REPORTES ════════════════════════════════════════════════

$navy:#0A354E; $orange:#EB7D10; $white:#fff;
$g200:#e8eaed; $g500:#6b7280; $g700:#374151;

.rp-dialog {
  :deep(.p-dialog-header){ font-weight:700; font-size:1rem; border-bottom:1px solid $g200; }
  :deep(.p-dialog-content){ padding:0 !important; }
  :deep(.p-dialog-footer){ border-top:1px solid $g200; padding:1rem 1.5rem; display:flex; justify-content:flex-end; }

  // Tabs del modal
  :deep(.p-tabview-nav) { background:#f8f9fa; border:none; border-bottom:1px solid $g200; padding:.25rem .25rem 0; gap:.25rem; }
  :deep(.p-tabview-nav-link) { border:none !important; border-radius:8px 8px 0 0 !important; padding:.6rem 1rem !important; font-size:.82rem; font-weight:600; color:$g500; background:transparent; transition:all .15s; }
  :deep(.p-highlight .p-tabview-nav-link) { background:$white !important; color:$navy !important; border-bottom:2px solid $navy !important; }
  :deep(.p-tabview-panels) { padding:0; background:$white; }
}

.rp-modal-body { min-height:320px; }

.rp-tab-header { display:flex; align-items:center; gap:.35rem; font-size:.8rem; }

.rp-tab-content { padding:1.5rem; display:flex; flex-direction:column; gap:.75rem; }

.rp-section-label { display:flex; align-items:center; gap:.35rem; font-size:.72rem; font-weight:700; color:$navy; text-transform:uppercase; letter-spacing:.5px; padding-bottom:.5rem; border-bottom:1px solid $g200; i{font-size:12px;} }

/* Tarjetas radio de tipo filtro */
.rp-radio-group { display:grid; grid-template-columns:repeat(2,1fr); gap:.65rem; }
.rp-radio-card { display:flex; align-items:center; gap:.65rem; padding:.75rem; border:1px solid $g200; border-radius:8px; cursor:pointer; transition:all .15s; &:hover{border-color:#93c5fd;background:#f8faff;} }
.rp-radio-card--on { background:#f0f9ff; border-color:#7dd3fc; }
.rp-radio-body { display:flex; align-items:center; gap:.6rem; flex:1; }
.rp-radio-icon { width:28px; height:28px; border-radius:6px; display:flex; align-items:center; justify-content:center; flex-shrink:0; i{font-size:12px;} }
.rp-radio-title { font-size:.8rem; font-weight:600; color:$g700; }
.rp-radio-sub   { font-size:.7rem; color:$g500; margin-top:1px; }

/* Campos de formulario */
.rp-form-field { display:flex; flex-direction:column; gap:.3rem; label{font-size:.68rem;font-weight:700;color:$g500;text-transform:uppercase;letter-spacing:.5px;} }
.rp-date-grid  { display:grid; grid-template-columns:repeat(2,1fr); gap:.75rem; }

/* Botones */
.rp-btn-primary { display:inline-flex; align-items:center; justify-content:center; gap:.35rem; background:$navy; color:#fff; border:none; border-radius:8px; padding:.5rem 1.1rem; font-size:.82rem; font-weight:600; cursor:pointer; transition:background .15s; i{font-size:13px;} &:hover{background:#0c4f77;} &:disabled{opacity:.6;cursor:not-allowed;} }
.rp-btn-outline  { display:inline-flex; align-items:center; gap:.35rem; background:$white; color:$g700; border:1px solid $g200; border-radius:8px; padding:.45rem .9rem; font-size:.82rem; font-weight:600; cursor:pointer; &:hover{border-color:$navy;color:$navy;} }
.rp-btn-full    { width:100%; }

/* Botones de formato descarga */
.rp-formato-btns { display:flex; gap:.5rem; flex-wrap:wrap; }
.rp-btn-formato { display:inline-flex; align-items:center; gap:.4rem; background:$white; border:1px solid $g200; border-radius:8px; padding:.45rem .875rem; font-size:.82rem; font-weight:600; color:$g700; cursor:pointer; transition:all .15s; i{font-size:14px;} &:hover{border-color:$navy;background:#f8faff;} &:disabled{opacity:.6;cursor:not-allowed;} }

/* Radio formato archivo */
.rp-formato-radio { display:flex; gap:.5rem; flex-wrap:wrap; }
.rp-formato-opt   { display:inline-flex; align-items:center; gap:.4rem; padding:.4rem .875rem; border:1px solid $g200; border-radius:8px; cursor:pointer; font-size:.82rem; font-weight:600; color:$g700; transition:all .15s; &:hover{border-color:#93c5fd;background:#f8faff;} i{font-size:14px;} }
.rp-formato-opt--on { background:#f0f9ff; border-color:#7dd3fc; }

/* Card de vehículo encontrado */
.rp-vehiculo-card { display:flex; align-items:center; gap:.875rem; padding:.875rem 1rem; background:#f0f9ff; border:1px solid #bfdbfe; border-radius:8px; }
.rp-vehiculo-icon { width:40px; height:40px; border-radius:8px; background:#dbeafe; display:flex; align-items:center; justify-content:center; flex-shrink:0; i{font-size:1.1rem;color:#1e40af;} }
.rp-vehiculo-placa { font-size:.95rem; font-weight:700; color:$navy; }
.rp-vehiculo-marca { font-size:.78rem; color:$g500; margin-top:2px; }
</style>
